/* CARDORI upload examples: compact, scoped, no personalization controller. */
function cardoriHammeredHandwriting20261028() {
  return /\/products\/personalisierter-armreif-gehammert-mit-innengravur-handmade\/?$/.test(location.pathname);
}
function cardoriUploadExampleMarkup20261024(type) {
  var ready = type === 'ready';
  var hammered = ready && cardoriHammeredHandwriting20261028();
  var script = document.querySelector('script[src*="/cardori-personalizer.js"]');
  if (!script || !script.src) return '';
  var entries = ready ? [
    ['Handschrift', 'handschrift', 'handschrift'],
    ['Logo', 'logo', 'logo'],
    ['Zeichnung', 'zeichnung', 'zeichnung']
  ] : [
    ['Paar', 'paar-foto', 'paar-linien'],
    ['Auto', 'auto-foto', 'auto-linien'],
    ['Motorrad', 'motorrad-foto', 'motorrad-linien'],
    ['Tier', 'hund-foto', 'tier-linien']
  ];
  function url(name) { var asset = new URL('cardori-example-' + name + (name === 'hund-foto' ? '.png' : '.webp'), script.src); asset.searchParams.set('v', '20261025v4-examples'); return asset.href; }
  function image(name, label) {
    return '<img src="' + url(name) + '" alt="' + label + '" width="400" height="400" loading="lazy" decoding="async">';
  }
  var tabs = entries.map(function (entry, i) {
    return '<button type="button" class="cardori-example-pick" data-cardori-example-index="' + i + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">' + entry[0] + '</button>';
  }).join('');
  var panels = entries.map(function (entry, i) {
    return '<div class="cardori-example-panel" data-cardori-example-panel="' + i + '"' + (i ? ' hidden' : '') + '><div class="cardori-example-comparison">' +
      '<figure><figcaption>' + (ready ? 'DEINE VORLAGE' : 'DEIN FOTO') + '</figcaption><div class="cardori-example-picture' + (ready ? ' cardori-example-paper' : '') + '">' + image(entry[1], ready ? entry[0] + ' auf Papier – Beispielvorlage' : 'Ausgangsfoto: ' + entry[0]) + '</div></figure>' +
      '<span class="cardori-example-arrow" aria-hidden="true">→</span>' +
      '<figure><figcaption>' + (ready ? 'GRAVURMOTIV' : 'LINIENZEICHNUNG') + '</figcaption><div class="cardori-example-picture">' + image(entry[2], ready ? (hammered ? 'Bereinigte Beispielvorlage auf Weiß: ' + entry[0] : entry[0] + ' mit unveränderter Anordnung auf Weiß') : 'Beispiel einer Linienzeichnung: ' + entry[0]) + '</div></figure></div></div>';
  }).join('');
  return '<div class="cardori-upload-examples" data-cardori-examples="' + (ready ? 'ready' : 'photo') + '"><div class="cardori-example-heading">' + (ready ? (hammered ? 'So bereiten wir deine Vorlage auf' : 'So bleibt deine Vorlage erhalten') : 'Zum Beispiel') + '</div><div class="cardori-example-picks" role="group" aria-label="Beispielmotiv auswählen">' + tabs + '</div><div class="cardori-example-panels" aria-live="polite">' + panels + '</div><p class="cardori-example-footnote">' + (ready ? (hammered ? 'Die Beispiele zeigen die Bereinigung der Vorlage. Bei diesem Armreif kann zusätzlich eine einzeilige Anordnung nötig sein.' : 'Beispielhafte Aufbereitung. Deine Handschrift und Textanordnung bleiben erhalten.') : 'Auch andere Motive sind möglich. Ein klar erkennbares Hauptmotiv ist ideal. Das Ergebnis hängt von deinem Foto ab.') + '</p></div>';
}

function cardoriUploadGuideMarkup20261024(type) {
  var ready = type === 'ready';
  var hammered = ready && cardoriHammeredHandwriting20261028();
  return '<div class="cardori-upload-guide__note"><span class="cardori-upload-guide__icon" aria-hidden="true">' + (ready ? '✓' : 'i') + '</span><div class="cardori-upload-guide__copy"><strong>' + (ready ? (hammered ? 'Deine Vorlage für den Armreif' : 'Deine Handschrift bleibt im Original') : 'Für viele Fotomotive geeignet') + '</strong><span>' + (ready ? (hammered ? 'Störende Schatten oder Papierreste bereinigen wir vor der Gravur. Deine Handschrift bleibt erhalten. Für die schmale Innenseite ordnen wir mehrzeilige Handschrifttexte bei Bedarf in einer Zeile an.' : 'Störende Schatten oder Papierreste in der Vorschau bereinigen wir vor der Gravur. Handschrift, Wortabstände und Textanordnung verändern wir dabei nicht.') : 'Menschen, Tiere, Fahrzeuge, Häuser und vieles mehr – wichtig ist ein klar erkennbares Hauptmotiv.') + '</span></div></div>' + cardoriUploadExampleMarkup20261024(type);
}

var cardoriUploadExampleSelections20261024 = Object.create(null);
function cardoriBindUploadExamples20261024(guide, option) {
  if (!guide || guide.dataset.cardoriExamplesBound === 'true') return;
  guide.dataset.cardoriExamplesBound = 'true';
  var block = guide.querySelector('.cardori-upload-examples');
  if (!block) return;
  var optionId = option && option.getAttribute('opt-id');
  var key = optionId ? optionId + ':' + block.getAttribute('data-cardori-examples') : null;
  function select(index) {
    var exists = block.querySelector('[data-cardori-example-index="' + index + '"]');
    if (!exists) return;
    block.querySelectorAll('.cardori-example-pick').forEach(function (button) {
      button.setAttribute('aria-pressed', button === exists ? 'true' : 'false');
    });
    block.querySelectorAll('.cardori-example-panel').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cardori-example-panel') !== index;
    });
  }
  if (key && cardoriUploadExampleSelections20261024[key] !== undefined) select(cardoriUploadExampleSelections20261024[key]);
  guide.addEventListener('click', function (event) {
    var pick = event.target && event.target.closest && event.target.closest('.cardori-upload-examples .cardori-example-pick');
    if (!pick) return;
    if (pick.closest('.cardori-upload-examples') !== block) return;
    event.preventDefault();
    event.stopPropagation();
    var index = pick.getAttribute('data-cardori-example-index');
    if (key) cardoriUploadExampleSelections20261024[key] = index;
    select(index);
  });
}

(function () {
  const watched = new WeakSet();
  const controlStates = new WeakMap();

  let loadedEngine = null;
  const boundEngines = new WeakSet();
  function ovalProduct() { return /\/products\/(?:oval-schlusselanhanger-mit-gravur-handschrift-gravur|rechteck-schlusselanhanger-mit-gravur|plate-halskette-mit-gravur-handschrift-gravur)\/?$/.test(location.pathname); }
  function currentEngine() { return window.engraver?.canvas?.lowerCanvasEl?.id === "preview-canvas" ? window.engraver : loadedEngine || window.engraver; }

  // UI-only guide: never add an object to the engraving/export canvas.
  let guideTimer=0;
  function hideGuide(){ document.querySelectorAll('.cardori-area-guide,.cardori-area-note').forEach(n=>n.remove()); }
  function showGuide(engine, message=''){
    if(!ovalProduct() || !engine?.canvas) return;
    hideGuide(); clearTimeout(guideTimer);
    const elements=engine.cardoriControlElements?engine.cardoriControlElements():engine.getActionableElements();
    const item=elements.length===1 && elements[0];
    if(!item || item.type!=='bounded-text' || !item.allowEdit) return;
    const canvas=engine.canvas, host=canvas.lowerCanvasEl?.parentElement;
    if(!host || !item.getCoords) return;
    const v=canvas.viewportTransform || [1,0,0,1,0,0];
    const points=item.getCoords(true,true).map(p=>[v[0]*p.x+v[2]*p.y+v[4],v[1]*p.x+v[3]*p.y+v[5]].join(',')).join(' ');
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.classList.add('cardori-area-guide'); svg.setAttribute('viewBox','0 0 '+canvas.width+' '+canvas.height); svg.setAttribute('aria-hidden','true');
    svg.style.cssText='position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;overflow:visible';
    const polygon=document.createElementNS(svg.namespaceURI,'polygon'); polygon.setAttribute('points',points);polygon.setAttribute('fill','none');polygon.setAttribute('stroke',message?'#99764a':'#738476');polygon.setAttribute('stroke-width',message?'2':'1.2');polygon.setAttribute('stroke-dasharray','5 4');polygon.setAttribute('vector-effect','non-scaling-stroke');svg.appendChild(polygon); host.appendChild(svg);
    if(message){const note=document.createElement('div');note.className='cardori-area-note';note.setAttribute('role','status');note.textContent=message;note.style.cssText='position:absolute;left:8px;right:8px;bottom:70px;z-index:4;pointer-events:none;text-align:center;font:12px/1.35 sans-serif;color:#354039;background:rgba(255,255,255,.95);padding:5px 8px;border-radius:5px';host.appendChild(note);}
    guideTimer=setTimeout(hideGuide,message?2600:1600);
  }
  function centerControl(controls,engine){
    if(!ovalProduct())return;
    let button=controls.querySelector('.cardori-center-text');
    if(!button){button=document.createElement('button');button.type='button';button.className='cardori-center-text';button.textContent='Zentrieren';button.title='Text im erlaubten Bereich zentrieren';button.setAttribute('aria-label','Text zentrieren');button.style.cssText='grid-column:1 / -1;grid-row:2;min-height:36px;border:0;background:none;color:#354039;text-decoration:underline;text-underline-offset:3px;font:13px/1.2 sans-serif;cursor:pointer';controls.appendChild(button);button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();const current=currentEngine();const items=current.cardoriResumeSelection?current.cardoriResumeSelection():current.getActionableElements();if(items.length!==1)return;const item=items[0];if(item.type!=='bounded-text'||!item.allowEdit||item.lockMovement)return;item.setTextOffset(item.left-item.initialLeft,item.top-item.initialTop);current.canvas.fire('text:moving',{object:item,parameters:item.getEditModeParameters()});current.canvas.requestRenderAll();showGuide(current);queue();});}
    const items=engine.cardoriControlElements?engine.cardoriControlElements():engine.getActionableElements();
    button.hidden=items.length!==1||items[0].type!=='bounded-text'||!items[0].allowEdit||items[0].lockMovement;
  }
  // Higher native template limits are required; never raise them only at runtime.
  function bindOvalTextSize(engine) {
    const templateId = engine?.currentProduct?.id;
    if (!['4c75712a-b19c-4f78-a86c-c84223138d2d','1a419d7a-eae3-4c15-af8d-1a67cebbc015'].includes(templateId) || !engine?.canvas) return;
    // A cloned default-preview placeholder can share its UUID with its visible
    // counterpart. Native serialization resolves the first UUID match. Keep the
    // actual text first without changing canvas order, visibility or export IDs.
    if (Array.isArray(engine.textObjects)) {
      const outside = engine.textObjects.filter(item => [901, 1901].includes(Number(item.id)) && item.outsideCanvas && engine.textObjects.some(other => other !== item && other.uuid === item.uuid && !other.outsideCanvas));
      if (outside.length) engine.textObjects.splice(0, engine.textObjects.length, ...engine.textObjects.filter(item => !outside.includes(item)), ...outside);
    }
      let state = engine.cardoriTextSizeState;
    if (!state) {
      state = engine.cardoriTextSizeState = { restoring: 0, objects: new WeakSet() };
      ['loadCustomizationFromData', 'adjustPlaceholderFromSharedCustomization'].forEach(name => {
        const original = engine[name];
        if (typeof original !== 'function') return;
        engine[name] = async function () {
          state.restoring++;
          engine.canvas.getObjects().filter(item => item.cardoriSizeTarget != null).forEach(item => item.forceFontSize(false));
          try { return await original.apply(this, arguments); }
          finally {
            bindOvalTextSize(engine);
            engine.canvas.getObjects().filter(item => item.cardoriSizeTarget != null).forEach(item => { item.cardoriSizeTarget = item.getFontSize(); });
            state.restoring--;
          }
        };
      });
    }
    engine.canvas.getObjects().filter(item => [901, 1901].includes(Number(item.id)) && item.type === 'bounded-text' && item.allowEdit).forEach(item => {
      if (state.objects.has(item)) return;
      state.objects.add(item);
      const originalText = item.setText, originalForce = item.forceFontSize;
      let internal = false;
      item.cardoriSizeTarget = state.restoring ? item.getFontSize() : (templateId === '1a419d7a-eae3-4c15-af8d-1a67cebbc015' ? item.maxSizePx : item.minSizePx * (17 / 6));
      item.forceFontSize = function (size) {
        const manual = !internal && !state.restoring && Number.isFinite(size) && size > 0;
        if (manual) this.cardoriSizeTarget = size;
        const result = originalForce.apply(this, arguments);
        if (manual) {
          internal = true;
          try { originalText.call(this, this.getText()); } finally { internal = false; }
        }
        return result;
      };
      item.setText = function (text, restoringDimensions) {
        if (state.restoring || restoringDimensions) return originalText.apply(this, arguments);
        internal = true;
        try {
          const target = Math.min(this.maxSizePx, this.cardoriSizeTarget);
          originalForce.call(this, false);
          this.item(0).set("maxFontSize", target);
          let result = originalText.apply(this, arguments);
          // Native long-text fit can release the forced size; preserve the customer's
          // intended size when a later short input would otherwise jump to the cap.
          if (this.getFontSize() > target + 0.01) {
            originalForce.call(this, target);
            result = originalText.apply(this, arguments);
          }
          return result;
        } finally { internal = false; }
      };
      if (!state.restoring) item.setText(item.getText());
    });
    engine.canvas.requestRenderAll();
  }
  
  function bindSelection(engine) {
    if (ovalProduct()) bindOvalTextSize(engine);
    if (!ovalProduct() || !engine?.canvas?.on || boundEngines.has(engine.canvas)) return;
    boundEngines.add(engine.canvas);
    ['object:moving','object:scaling','object:rotating'].forEach(name=>engine.canvas.on(name,()=>showGuide(engine)));
    const original = engine.getActionableElements;
    let reading = false, last = [];
    engine.cardoriControlElements = function () {
      if (!reading) return engine.getActionableElements();
      const objects = engine.canvas.getObjects();
      return last.filter(item => objects.includes(item) && item.visible !== false && (!item.isVisiblePreview || item.isVisiblePreview()));
    };
    engine.cardoriResumeSelection = function () {
      const previous = engine.cardoriControlElements();
      reading = false;
      const item = previous[0], target = item && (item._controlRectangle || item._maskBoundsRectangle || item);
      if (target) { target.set({hasBorders:true,hasControls:true}); engine.canvas.setActiveObject(target); engine.canvas.requestRenderAll(); }
      return engine.getActionableElements();
    };
    engine.getActionableElements = function () { if (reading) return []; const selected = original.apply(this, arguments); if (selected.length) last = selected; return selected; };
    engine.canvas.on('mouse:down', event => {
      const target = event.target;
      const elements = engine.canvas.getObjects();
      const editable = elements.some(item => (item.allowEdit || item.oldAllowEdit || item.allowUserUpload) && (item === target || item._controlRectangle === target || item._maskBoundsRectangle === target));
      reading = !editable;
      if (reading) { elements.forEach(item => { if(item._controlRectangle) item._controlRectangle.set({hasBorders:false,hasControls:false}); }); engine.clearSelection(); hideGuide(); } else showGuide(engine);
      queue();
    });
    document.addEventListener('input', event => { if (event.target.matches('input[name^="properties["],textarea[name^="properties["]')) { reading = false; queue(); } }, true);
    document.addEventListener('change', event => { if (event.target.closest('.customily-modal-container,#customily-options,#csh-list-preview-modal,.csh-product-customizer-modal')) { reading = false; queue(); } }, true);
  }
  document.addEventListener('productLoaded', event => { if (event.detail?.engraver?.canvas?.lowerCanvasEl?.id === "preview-canvas") { loadedEngine = event.detail.engraver; bindSelection(loadedEngine); queue(); } }, true);
  function quarterTurn(controls, engine) {
    if (!ovalProduct()) return;
    let button = controls.querySelector('.cardori-rotate-quarter');
    if (!button) {
      button = document.createElement('button'); button.type='button'; button.className='cardori-rotate-quarter'; button.innerHTML='<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M25 10A12 12 0 1 0 27 20M25 4v7h-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><text x="16" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-size="10" fill="currentColor">90°</text></svg>'; button.setAttribute('aria-label','90° drehen'); button.title='90° drehen';
      button.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        const current = currentEngine();
        const elements = current.cardoriResumeSelection ? current.cardoriResumeSelection() : current.getActionableElements();
        if (!elements.length || elements.some(item => item.type !== 'bounded-text' || item.lockRotation)) return;
        const originals=elements.map(item=>({size:item.getFontSize(),min:item.minSizePx,angle:item.getEditModeParameters().angle}));
        let ready=true;
        elements.forEach(item=>{
          const angle=((item.getEditModeParameters().angle%360)+360)%360, target=angle+(90-angle%90);
          if (!item.allowEdit) return;
          item.minSizePx=Math.min(item.minSizePx,originals[elements.indexOf(item)].min*.5);
          for(let attempt=0;attempt<30;attempt++) {
            const limit=item.constrainRotationToBoundingBox(target);
            if (limit.minRotationDelta!==0 && limit.maxRotationDelta!==0) { item.minSizePx=Math.min(originals[elements.indexOf(item)].min,item.getFontSize()); return; }
            const size=item.getFontSize()*.94;
            if(size<item.minSizePx) { ready=false; return; }
            item.forceFontSize(size); item._controlRectangle.set({width:item.item(0).width,height:item.item(0).height,scaleX:1,scaleY:1}); item._controlRectangle.setCoords(); item.textTransformed=true;
          }
          ready=false;
        });
        if (!ready) { elements.forEach((item,index)=>{ item.forceFontSize(originals[index].size); if(item.allowEdit){item._controlRectangle.set({width:item.item(0).width,height:item.item(0).height,scaleX:1,scaleY:1});item._controlRectangle.setCoords();} item.minSizePx=originals[index].min; }); current.canvas.requestRenderAll(); showGuide(current,'Zum Drehen bitte etwas verkleinern'); queue(); return; }
        const steps=elements.map(item => item.rotationStep);
        try { elements.forEach(item => { const angle=((item.getEditModeParameters().angle % 360)+360)%360; item.rotationStep=-(90-angle%90); }); current.rotateActiveImagePlaceholder(); }
        finally { elements.forEach((item,index)=>{item.rotationStep=steps[index];}); }
        queue();
      });
      controls.appendChild(button);
    }
    const elements=engine.cardoriControlElements ? engine.cardoriControlElements() : engine.getActionableElements();
    button.hidden=!elements.length || elements.some(item=>item.type!=='bounded-text');
    button.disabled=elements.some(item=>item.lockRotation);
  }
  function controlGeometry(engine) {
    return JSON.stringify([engine.canvas?.getActiveObject?.()?.id ?? null, engine.getActionableElements().map(element => [element.id, element.left, element.top, element.width, element.height, element.scaleX, element.scaleY, element.angle, element.fontSize, element.getObjects?.().map(child => [child.left, child.top, child.width, child.height, child.fontSize, child.scaleX, child.scaleY, child.angle])])]);
  }
  function updateLimits(controls, buttons, engine) {
    let state = controlStates.get(controls);
    if (!state) {
      state = { geometry: '', blocked: new Set(), successful: new Set() };
      controlStates.set(controls, state);
      controls.addEventListener('contextmenu', event => event.preventDefault());
      ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'pointercancel', 'touchcancel', 'click', 'keydown'].forEach(type => controls.addEventListener(type, event => {
        const button = event.target.closest('.cl-mobile-control-wrapper');
        if (!button) return;
        if (['pointerdown','mousedown','touchstart','keydown'].includes(type)) { const engine=currentEngine(); if (engine?.cardoriResumeSelection) { engine.cardoriResumeSelection(); updateLimits(controls,buttons,engine); } }
        // Never swallow release events: native hold/repeat must receive touchend and pointerup.
        if (button.getAttribute('aria-disabled') === 'true' && !['pointerup','touchend','mouseup','pointercancel','touchcancel'].includes(type)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        const current = currentEngine();
        if (!current || typeof current.getActionableElements !== 'function') return;
        if (type === 'pointerdown' || type === 'mousedown' || type === 'touchstart') { state.before = controlGeometry(current); state.action = button; showGuide(current); return; }
        if (!['click','pointerup','touchend'].includes(type) && !(type === 'keydown' && ['Enter',' '].includes(event.key))) return;
        if (state.action && state.action !== button) return;
        if (!state.before && ['click','pointerup','touchend'].includes(type) && state.completedAt && Date.now() - state.completedAt < 500) return;
        const before = state.before || controlGeometry(current);
        state.before = '';
        state.completedAt = Date.now();
        const revision = state.revision = (state.revision || 0) + 1;
        setTimeout(() => requestAnimationFrame(() => {
          if (revision !== state.revision) return;
          if (current !== currentEngine()) return;
          const after = controlGeometry(current);
          if (after !== state.geometry) { state.blocked.clear(); state.geometry = after; }
          if (after !== before) state.successful.add(button);
          // A masked upload keeps its placeholder geometry while its image crop moves.
          // Only bounded text geometry can reliably prove a reached native limit.
          if (after === before && current.canvas?.getActiveObject?.() && current.getActionableElements().length > 0 && current.getActionableElements().every(element => !['image-placeholder', 'vector-placeholder'].includes(element.type)) && !button.classList.contains('cardori-element-switch')) state.blocked.add(button);
          queue();
        }), 100);
      }, true));
    }
    const geometry = controlGeometry(engine);
    if (state.geometry !== geometry) { state.geometry = geometry; state.blocked.clear(); }
    const selected = engine.cardoriControlElements ? engine.cardoriControlElements() : engine.getActionableElements();
    const all = [...buttons, controls.querySelector('.cardori-rotate-right')].filter(Boolean);
    all.forEach(button => {
      const index = Array.from(buttons).indexOf(button);
      const locked = !selected.length || state.blocked.has(button) || selected.every(element => index >= 0 && index < 4 ? element.lockMovement : index === 5 || index === 6 ? element.lockScaling : index === 7 ? false : element.lockRotation);
      const disabled = locked ? 'true' : 'false';
      if (button.getAttribute('aria-disabled') !== disabled) button.setAttribute('aria-disabled', disabled);
      if (button.classList.contains('cardori-control-disabled') !== !!locked) button.classList.toggle('cardori-control-disabled', !!locked);
      const label = index < 0 ? 'Nach rechts drehen' : labels[index];
      const title = label + (state.blocked.has(button) ? ' – Grenze erreicht' : '');
      if (button.title !== title) button.title = title;
    });
  }
  const labels = ['Nach oben verschieben', 'Nach unten verschieben', 'Nach links verschieben', 'Nach rechts verschieben', 'Nach links drehen', 'Vergrößern', 'Verkleinern', 'Nächstes Element auswählen'];
  function enhanceRotation(controls, buttons) {
    if(window.matchMedia("(max-width:767px)").matches){ let parent=controls.parentElement; while(parent && !parent.matches(".customily-modal-container,#csh-list-preview-modal,.csh-product-customizer-modal") && parent!==document.body){if(!parent.classList.contains("cardori-controls-unclip"))parent.classList.add("cardori-controls-unclip");parent=parent.parentElement;} }
    const engine = currentEngine();
    if (!engine || typeof engine.getActionableElements !== 'function' || typeof engine.rotateActiveImagePlaceholder !== 'function') return;
    bindSelection(engine);
    quarterTurn(controls, engine);
    centerControl(controls, engine);
    if (!controls.querySelector('.cardori-rotate-right')) {
      const button = document.createElement('div');
      button.className = 'cl-mobile-control-wrapper cardori-rotate-right';
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'Nach rechts drehen');
      button.title = 'Nach rechts drehen';
      const symbol = buttons[4].querySelector('.customily-mobile-controls-item').cloneNode(true);
      symbol.querySelector('img').alt = '';
      button.append(symbol);
      function rotate(event) {
        event.preventDefault();
        event.stopPropagation();
        const current = currentEngine();
        if (!current || current.canvasImageLoading?.isEnabled) return;
        const elements = current.getActionableElements();
        if (!elements.length || elements.some(element => !Number.isFinite(element.rotationStep) || element.rotationStep <= 0)) return;
        const steps = elements.map(element => element.rotationStep);
        try {
          elements.forEach((element, index) => { element.rotationStep = -steps[index]; });
          current.rotateActiveImagePlaceholder();
        } finally {
          elements.forEach((element, index) => { element.rotationStep = steps[index]; });
        }
      }
      button.addEventListener('click', rotate);
      button.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') rotate(event); });
      controls.insertBefore(button, buttons[4]);
    }
    updateLimits(controls, buttons, engine);
    const switcher = buttons[7];
    if (switcher && engine.canvas?.getObjects) {
      const candidates = engine.canvas.getObjects().filter(element => {
        if (!element.visible || (typeof element.isVisiblePreview === 'function' && !element.isVisiblePreview())) return false;
        if (/\/products\/oval-schlusselanhanger-mit-gravur-handschrift-gravur\/?$/.test(location.pathname)) {
          const rear = document.querySelector('input[id$="-cl-option-99999999999-cl-value-id-2"]');
          if ((Number(element.id) >= 1000) !== !!rear?.checked) return false;
        }
        if (element.type === 'bounded-text') return (element.allowEdit || element.oldAllowEdit) && !!element.getText?.();
        if (element.type === 'vector-placeholder') return (element.allowUserUpload || element.allowEdit) && !element.starMapConfig && !element.qrConfig && !!(element.pdf || element.svgString);
        if (element.type === 'image-placeholder') {
          if ((element.dynamicImagesPath && !element.allowEdit) || element.mapConfig || element.crossword || element.calendar || element.wordCloudConfig || element.wordSearchConfig || (element.lockMovement && element.lockScaling)) return false;
          const image = element.item?.(0);
          return !!image?.getSrc?.() && image.width > 1 && image.height > 1;
        }
        return false;
      });
      const needed = new Set(candidates.map(element => element.id)).size > 1;
      if (!switcher.classList.contains('cardori-element-switch')) switcher.classList.add('cardori-element-switch');
      if (switcher.classList.contains('cardori-element-switch-hidden') === needed) switcher.classList.toggle('cardori-element-switch-hidden', !needed);
    }
  }
  function updateCartPresentation() {
    if (!document.getElementById('cardori-cart-summary-style')) {
      const style = document.createElement('style'); style.id = 'cardori-cart-summary-style';
      style.textContent = '.customily-property[cl-property="Edit"]{margin:0 0 5px!important;line-height:1.3!important}.customily-property[cl-property="Edit"] a{display:inline!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;min-height:0!important;color:#354039!important;font-size:13px!important;font-weight:400!important;line-height:1.3!important;text-decoration:underline!important;text-underline-offset:3px;white-space:nowrap;box-sizing:border-box}.cart-item__quantity>.customily-property[cl-property="Edit"]{text-align:left}.cardori-cart-summary .cart-item__quantity{margin-top:4px!important;padding-top:0!important}.cardori-cart-summary .cart-item__description>.lightly-spaced-row:has(.line-item-property){margin-bottom:0!important}.customily-mobile-controls:has(.cardori-rotate-quarter:not([hidden])){grid-template-columns:repeat(9,minmax(0,1fr))!important}.cardori-rotate-quarter{order:9;grid-row:1;grid-column:9;min-width:0!important;width:100%!important;height:45px!important;min-height:40px!important;padding:0!important;border:1px solid #d3d6d1!important;border-radius:8px!important;background:#f5f7f4!important;color:#354039!important;font-size:14px!important;line-height:1!important;white-space:nowrap;cursor:pointer}.cardori-rotate-quarter[hidden]{display:none!important}.customily-mobile-controls .customily-mobile-controls-item{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;height:100%!important;min-width:0!important;min-height:0!important;padding:3px!important;box-sizing:border-box!important}.customily-mobile-controls .customily-mobile-controls-item img,.customily-mobile-controls .cardori-rotate-quarter svg{display:block!important;width:70%!important;height:70%!important;max-width:28px!important;max-height:28px!important;object-fit:contain!important;flex-shrink:1!important;margin:auto!important}.customily-mobile-controls .cl-mobile-control-wrapper{min-width:0!important;overflow:hidden!important}.customily-mobile-controls .cardori-rotate-quarter{display:flex!important;align-items:center!important;justify-content:center!important}.customily-mobile-controls .cardori-rotate-quarter[hidden]{display:none!important}.customily-modal-container .options-control-preview-button,#csh-list-preview-modal .options-control-preview-button,.csh-product-customizer-modal .options-control-preview-button{display:none!important}.cardori-cart-side{font-weight:600;color:#354039;margin:8px 0 3px}.cardori-cart-summary .line-item-property{line-height:1.45;margin:2px 0;overflow-wrap:anywhere}.cardori-cart-summary .line-item-property__label{color:#687168}.cardori-cart-summary .line-item-property__value{font-weight:500}body.cardori-customily-product .customily-modal-container button.options-control-button.options-control-preview-button,body.cardori-customily-product #csh-list-preview-modal button.options-control-button.options-control-preview-button,body.cardori-customily-product .csh-product-customizer-modal button.options-control-button.options-control-preview-button{display:none!important;visibility:hidden!important;pointer-events:none!important}@media(max-width:767px){.customily-modal-container .canvas-container:has(>.customily-mobile-controls),#csh-list-preview-modal .canvas-container:has(>.customily-mobile-controls),.csh-product-customizer-modal .canvas-container:has(>.customily-mobile-controls){overflow:visible!important}.customily-modal-container .customily-mobile-controls:has(.cardori-rotate-right),#csh-list-preview-modal .customily-mobile-controls:has(.cardori-rotate-right),.csh-product-customizer-modal .customily-mobile-controls:has(.cardori-rotate-right){width:min(420px,calc(100vw - 24px))!important;min-width:min(420px,calc(100vw - 24px))!important;max-width:none!important;left:50%!important;transform:translateX(-50%)!important;margin-left:0!important;margin-right:0!important;padding:4px!important;gap:4px!important;height:auto!important;flex-shrink:0!important;grid-auto-rows:44px!important}.customily-mobile-controls:has(.cardori-rotate-right)>.cl-mobile-control-wrapper,.customily-mobile-controls:has(.cardori-rotate-right)>.cardori-rotate-quarter{height:44px!important;min-height:44px!important;max-height:44px!important;width:100%!important;min-width:0!important;max-width:none!important;box-sizing:border-box!important;border-radius:8px!important}.customily-mobile-controls:has(.cardori-rotate-right) .customily-mobile-controls-item{height:100%!important;max-height:100%!important;width:100%!important;padding:3px!important}.customily-mobile-controls:has(.cardori-rotate-right) .customily-mobile-controls-item img,.customily-mobile-controls:has(.cardori-rotate-right) .cardori-rotate-quarter svg{width:26px!important;height:26px!important;max-width:calc(100% - 4px)!important;max-height:26px!important;flex:0 1 auto!important;object-fit:contain!important}}.customily-modal-container button.csh-list-preview-button,#csh-list-preview-modal button.csh-list-preview-button,.csh-product-customizer-modal button.csh-list-preview-button{display:none!important}@media(max-width:767px){.cardori-controls-unclip{overflow:visible!important;clip-path:none!important}}'; document.head.appendChild(style);
    }
    document.querySelectorAll('.customily-property[cl-property="Edit"]').forEach(edit => {
      const link = edit.querySelector('a[href*="customizationId="]');
      if (!link) return;
      const list = edit.closest("[data-merge-list-item],.cart-item") || edit.parentElement;
      const quantity = list.querySelector(".cart-item__quantity");
      if (quantity && edit.parentElement !== quantity) quantity.insertBefore(edit,quantity.firstChild);
      if (!list.classList.contains('cardori-cart-summary')) list.classList.add('cardori-cart-summary');
      const rows = Array.from(list.querySelectorAll('.line-item-property'));
      rows.forEach(row => {
        const label = row.querySelector('.line-item-property__label'), value = row.querySelector('.line-item-property__value');
        if (!label || !value) return;
        const name = label.textContent.trim(), text = value.textContent.trim();
        const technical = /^(?:Dein Wunschort|Wunschort wählen)(?: \(Rückseite\))?:?$/i.test(name) || /^Preview Page/i.test(name) || (/^Ich (bestätige|besitze)/i.test(name) && /^(on|true|1)$/i.test(text));
        const mode = /^(Gravur gestalten|Gravur Rückseite gestalten):?$/i.test(name);
        const rearToggle = /^Rückseite(?: ebenfalls)? gravieren/i.test(name);
        if ((technical || mode) && row.style.display !== 'none') row.style.display = 'none';
      });
      const visible = rows.filter(row => row.style.display !== 'none');
      const rear = visible.find(row => /\(Rückseite\)/.test(row.querySelector('.line-item-property__label')?.textContent || ''));
      function heading(before, side) {
        if (!before || list.querySelector('[data-cardori-cart-side="'+side+'"]')) return;
        const title = document.createElement('div'); title.className='cardori-cart-side'; title.dataset.cardoriCartSide=side; title.textContent=side; before.parentElement.insertBefore(title,before);
      }
      heading(visible.find(row => row !== rear && !/Rückseite/.test(row.querySelector('.line-item-property__label')?.textContent || '')), 'Vorderseite');
      heading(rear,'Rückseite');
    });

    document.querySelectorAll('.line-item-property').forEach(row => {
      const label = row.querySelector('.line-item-property__label');
      const value = row.querySelector('.line-item-property__value');
      if (!label) return;
      const name = label.textContent.trim();
      if (/^Preview Page/i.test(name) && row.style.display !== 'none') row.style.display = 'none';
      if (/^Rückseite(?: ebenfalls)? gravieren|^Rückseitengravur/i.test(name) && value && /^(on|true|1|ja|yes)$/i.test(value.textContent.trim())) {
        if (row.style.display) row.style.display = ''; if (value.hidden) value.hidden = false; if (value.style.display) value.style.display = '';
        if (value.textContent !== 'Ja') value.textContent = 'Ja';
        if (label.textContent !== 'Rückseitengravur:') label.textContent = 'Rückseitengravur:';
      }
      if (/^(?:Dein Wunschort|Wunschort wählen)(?: \(Rückseite\))?:?$|^Gravur (?:Rückseite )?gestalten:?$/i.test(name) && row.style.display !== 'none') row.style.display = 'none';
    });
    const modal = document.querySelector('#cl-cart-previews-modal');
    const front = modal?.querySelector('button[aria-label="Vorderseite"]');
    const rear = modal?.querySelector('button[aria-label="Rückseite"]');
    if (!front || !rear || front.parentElement !== rear.parentElement || front.parentElement.children.length !== 2) return;
    if (front.parentElement.firstElementChild !== front) front.parentElement.insertBefore(front, rear);
    if (!modal.dataset.cardoriFrontFirst) { modal.dataset.cardoriFrontFirst = 'true'; front.click(); }
    const image = modal.querySelector('img');
    if (!image || !['Vorderseite','Rückseite'].includes(image.alt)) return;
    const count = Array.from(image.parentElement.querySelectorAll('span')).find(span => /^[12]\s*\/\s*2$/.test(span.textContent.trim()));
    const caption = image.alt === 'Vorderseite' ? '1/2' : '2/2';
    if (count && count.textContent !== caption) count.textContent = caption;
  }
  let frame = 0;
  function update() {
    frame = 0;
    updateCartPresentation();
    document.querySelectorAll('carousel-slider').forEach(function (carousel) {
      const preview = carousel.querySelector('.cl-canvas-container');
      const controls = preview && preview.querySelector('.customily-mobile-controls');
      const active = controls && preview.getClientRects().length && controls.getClientRects().length && !controls.classList.contains('op-zero') && getComputedStyle(preview).display !== 'none';
      if (carousel.classList.contains('cardori-has-movable-controls') !== !!active) carousel.classList.toggle('cardori-has-movable-controls', !!active);
      if (!active) return;
      const bottom = Math.max(preview.getBoundingClientRect().bottom, controls.getBoundingClientRect().bottom);
      const height = Math.ceil(bottom - carousel.getBoundingClientRect().top) + 'px';
      if (carousel.style.getPropertyValue('--cardori-controls-preview-height') !== height) carousel.style.setProperty('--cardori-controls-preview-height', height);
      [preview, controls].forEach(function (element) {
        if (!watched.has(element)) {
          watched.add(element);
          resize.observe(element);
        }
      });
      const buttons = controls.querySelectorAll('.cl-mobile-control-wrapper:not(.cardori-rotate-right)');
      if (buttons.length === 7 || buttons.length === 8) buttons.forEach(function (button, index) {
        if (button.title !== labels[index]) button.title = labels[index];
        const icon = button.querySelector('img');
        if (icon && icon.alt !== labels[index]) icon.alt = labels[index];
      });
      if (buttons.length === 7 || buttons.length === 8) enhanceRotation(controls, buttons);
    });
    document.querySelectorAll(':is(.customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily-mobile-controls').forEach(function (controls) {
      const buttons = controls.querySelectorAll('.cl-mobile-control-wrapper:not(.cardori-rotate-right)');
      if (buttons.length !== 7 && buttons.length !== 8) return;
      buttons.forEach(function (button,index) {
        if (button.title !== labels[index]) button.title = labels[index];
        const icon = button.querySelector('img');
        if (icon && icon.alt !== labels[index]) icon.alt = labels[index];
      });
      enhanceRotation(controls,buttons);
    });
  }
  function queue() { if (!frame) frame = requestAnimationFrame(update); }
  const resize = new ResizeObserver(queue);
  new MutationObserver(queue).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']});
  window.addEventListener('resize', queue);
  window.addEventListener('customily-live-preview-shown', queue);
  queue();
})();

window.__cardoriPilotUploadExperience20260826 = true;
window.__cardoriPilotUploadExperienceTheme20260826v2 = true;
window.__cardoriPilotUploadExperienceTheme20260826v3 = true;
window.__cardoriPilotUploadExperienceTheme20260826v5 = true;
/* CARDORI personalization storefront behavior – extracted from layout/theme.liquid on 2026-08-21 */
(function () {
  function protectCustomilyPreview() {
    document.querySelectorAll(".cl-canvas-container").forEach(function (preview) {
      if (preview.dataset.cardoriGalleryGuard === "true") return;

      preview.addEventListener("click", function (event) {
        if (window.innerWidth < 768) {
          event.preventDefault();
          event.stopPropagation();
        }
      });

      preview.dataset.cardoriGalleryGuard = "true";
    });
  }

  window.addEventListener("customily-live-preview-shown", function () {
    requestAnimationFrame(protectCustomilyPreview);
    setTimeout(protectCustomilyPreview, 300);
    setTimeout(protectCustomilyPreview, 1000);
  });

  document.addEventListener("DOMContentLoaded", protectCustomilyPreview);
})();

/* CARDORI inline preview return – trusted-input-stabilized 2026-08-23 v11 */
(function () {
  window.cardoriPreviewReturnVersion = "2026-08-23-v11";
  document.documentElement.dataset.cardoriPreviewReturnVersion = "2026-08-23-v11";
  var buttonId = "cardori-preview-return";
  var previewRequested = true;
  var watchedPreview = null;
  var previewObserver = null;
  var installFrameRequested = false;

  function getPreview() {
    return document.querySelector(".cl-canvas-container");
  }

  function getVisibleThumbnailGroup(gallery) {
    var groups = Array.prototype.slice.call(
      gallery.querySelectorAll("carousel-slider.thumbnails")
    );

    return groups.find(function (group) {
      var rect = group.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }) || groups[0] || null;
  }

  function setReturnButtonVisible(visible) {
    var button = document.getElementById(buttonId);
    if (!button) return;
    button.classList.toggle("is-visible", Boolean(visible));
  }

  function previewIsVisible(preview) {
    return Boolean(
      preview &&
      window.getComputedStyle(preview).display !== "none" &&
      preview.getBoundingClientRect().width > 0
    );
  }

  function syncReturnButton() {
    var preview = getPreview();
    if (!preview || previewRequested) {
      setReturnButtonVisible(false);
      return;
    }

    setReturnButtonVisible(!previewIsVisible(preview));
  }

  function restoreInlinePreview(scrollToPreview) {
    var preview = getPreview();
    if (!preview) return;

    previewRequested = true;
    preview.style.removeProperty("display");

    if (window.getComputedStyle(preview).display === "none") {
      preview.style.display = "flex";
    }

    setReturnButtonVisible(false);

    if (scrollToPreview) {
      window.requestAnimationFrame(function () {
        preview.scrollIntoView({
          behavior: "auto",
          block: "center"
        });
      });
    }
  }

  function returnToPreview() {
    restoreInlinePreview(true);
  }

  function ensureSingleReturnButton(gallery) {
    var buttons = Array.prototype.slice.call(
      document.querySelectorAll("#" + buttonId + ", .cardori-preview-return")
    );
    var button = buttons.shift() || null;

    buttons.forEach(function (duplicate) {
      duplicate.remove();
    });

    if (!button) {
      button = document.createElement("button");
      button.id = buttonId;
      button.className = "cardori-preview-return";
      button.type = "button";
      button.textContent = "← Zurück zu deiner Vorschau";
      button.setAttribute(
        "aria-label",
        "Zurück zu deiner personalisierten Vorschau"
      );
      button.addEventListener("click", returnToPreview);
    }

    var thumbnailGroup = getVisibleThumbnailGroup(gallery);
    if (button.parentElement !== gallery || button.nextElementSibling !== thumbnailGroup) {
      gallery.insertBefore(button, thumbnailGroup);
    }

    return button;
  }

  function watchPreview(preview) {
    if (watchedPreview === preview) return;

    if (previewObserver) {
      previewObserver.disconnect();
    }

    watchedPreview = preview;
    previewObserver = new MutationObserver(function () {
      if (!previewRequested && previewIsVisible(preview)) {
        preview.style.display = "none";
        setReturnButtonVisible(true);
        return;
      }

      if (previewRequested && !previewIsVisible(preview)) {
        window.requestAnimationFrame(function () {
          restoreInlinePreview(false);
        });
        return;
      }

      syncReturnButton();
    });

    previewObserver.observe(preview, {
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }

  function installPreviewReturn() {
    var preview = getPreview();
    var gallery = preview && preview.closest(".media-gallery__inner");
    if (!preview || !gallery) return;

    ensureSingleReturnButton(gallery);
    watchPreview(preview);

    if (!previewRequested && previewIsVisible(preview)) {
      preview.style.display = "none";
    }

    syncReturnButton();
  }

  function queueInstall() {
    if (installFrameRequested) return;
    installFrameRequested = true;

    window.requestAnimationFrame(function () {
      installFrameRequested = false;
      installPreviewReturn();
    });
  }

  function queueInlinePreviewRestore(event) {
    if (!event || event.isTrusted !== true) return;

    previewRequested = true;
    setReturnButtonVisible(false);
    window.requestAnimationFrame(function () {
      restoreInlinePreview(false);
    });
    window.setTimeout(function () {
      restoreInlinePreview(false);
    }, 120);
    window.setTimeout(function () {
      restoreInlinePreview(false);
    }, 350);
  }

  function enterGalleryMode() {
    var preview = getPreview();
    previewRequested = false;

    if (preview) {
      preview.style.display = "none";
    }

    syncReturnButton();
  }

  function isCustomilyOptionInteraction(event) {
    var target = event.target instanceof Element ? event.target : null;
    return Boolean(target && target.closest(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal)"));
  }

  function getGalleryMediaLink(target) {
    if (!target) return null;

    return target.closest(
      '.media-gallery__inner a.thumbnail, ' +
      '.media-gallery__inner a[aria-label*="Galerieansicht laden"], ' +
      '.media-gallery__inner carousel-slider.thumbnails a'
    );
  }

  function handleGalleryIntent(event) {
    var target = event.target instanceof Element ? event.target : null;
    var thumbnail = getGalleryMediaLink(target);
    if (!thumbnail || !getPreview()) return false;

    window.setTimeout(enterGalleryMode, 80);
    return true;
  }


  document.addEventListener("input", function (event) {
    if (isCustomilyOptionInteraction(event)) {
      queueInlinePreviewRestore(event);
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (isCustomilyOptionInteraction(event)) {
      queueInlinePreviewRestore(event);
    }
  }, true);

  document.addEventListener("click", function (event) {
    var target = event.target instanceof Element ? event.target : null;

    if (target && target.closest(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal)")) {
      queueInlinePreviewRestore(event);
      return;
    }

    handleGalleryIntent(event);
  }, true);

  window.addEventListener("customily-live-preview-shown", function () {
    queueInstall();
    window.setTimeout(syncReturnButton, 0);
  });

  document.addEventListener("DOMContentLoaded", function () {
    installPreviewReturn();
    window.setTimeout(installPreviewReturn, 800);
    window.setTimeout(installPreviewReturn, 2200);
  });

  if (document.body) {
    var documentObserver = new MutationObserver(queueInstall);
    documentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

/* CARDORI length presentation – 2026-08-22 v3 */
(function () {
  function isLengthOption(group) {
    var name = (group.getAttribute("data-option") || "").toLowerCase();
    return name === "länge" || name === "laenge" || name === "length";
  }

  function toNumber(value) {
    return Number(String(value).replace(",", "."));
  }

  function formatNumber(value) {
    var rounded = Math.round(value * 100) / 100;
    return String(rounded).replace(".", ",");
  }

  function parseLength(value) {
    var raw = String(value || "").trim().replace(/\s+/g, " ");
    var extensionMatch = raw.match(
      /^(\d+(?:[.,]\d+)?)\s*(?:cm\s*)?\+\s*(\d+(?:[.,]\d+)?)\s*cm$/i
    );

    if (extensionMatch) {
      var baseNumber = toNumber(extensionMatch[1]);
      var extensionNumber = toNumber(extensionMatch[2]);

      if (Number.isFinite(baseNumber) && Number.isFinite(extensionNumber)) {
        return {
          type: "extension",
          base: formatNumber(baseNumber),
          extension: formatNumber(extensionNumber),
          total: formatNumber(baseNumber + extensionNumber),
        };
      }
    }

    var fixedMatch = raw.match(/^(\d+(?:[.,]\d+)?)\s*cm$/i);
    if (fixedMatch) {
      return {
        type: "fixed",
        base: formatNumber(toNumber(fixedMatch[1])),
      };
    }

    return {
      type: "other",
      label: raw.replace(/(\d)\s*cm\b/gi, "$1 cm"),
    };
  }

  function singleDisplay(length) {
    if (length.type === "extension") {
      return {
        value: length.base + " cm",
        meta: "Verlängerbar bis " + length.total + " cm",
      };
    }

    var value =
      length.type === "fixed" ? length.base + " cm" : length.label;

    return {
      value: value,
      meta: "",
    };
  }

  function buttonDisplay(length) {
    if (length.type === "extension") {
      return length.base + "–" + length.total + " cm";
    }

    if (length.type === "fixed") {
      return length.base + " cm";
    }

    return length.label;
  }

  function createSingleLengthRow(group, input, length) {
    var display = singleDisplay(length);
    var row = document.createElement("div");
    row.className = "cardori-length-row";
    row.innerHTML =
      '<div class="cardori-length-row__main">' +
        '<span class="cardori-length-row__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none">' +
            '<path d="M4 7.5h16M6.5 5v5M10 5v3M14 5v3M17.5 5v5M5 15.5c2.2 2.3 4.5 3.5 7 3.5s4.8-1.2 7-3.5" />' +
          "</svg>" +
        "</span>" +
        '<span class="cardori-length-row__text">' +
          '<span class="cardori-length-row__heading">' +
            "<strong>Kettenlänge</strong>" +
            '<span class="cardori-length-row__value"></span>' +
          "</span>" +
          '<span class="cardori-length-row__meta"></span>' +
        "</span>" +
      "</div>";

    row.querySelector(".cardori-length-row__value").textContent = display.value;

    var meta = row.querySelector(".cardori-length-row__meta");
    meta.textContent = display.meta;
    meta.hidden = !display.meta;

    group.classList.add("cardori-single-length");
    group.appendChild(row);
  }

  function enhanceMultipleLengths(group, inputs) {
    group.classList.add("cardori-multiple-lengths");
    var hasExtension = false;

    Array.prototype.forEach.call(inputs, function (input) {
      var length = parseLength(input.value);
      hasExtension = hasExtension || length.type === "extension";
      var valueNode = group.querySelector(
        'label[for="' + input.id + '"] .js-value'
      );
      if (valueNode) {
        valueNode.dataset.cardoriLengthRaw = input.value;
        valueNode.textContent = buttonDisplay(length);
      }
    });

    if (hasExtension) {
      var legend = group.querySelector("legend");
      if (legend) legend.textContent = "Verstellbarer Längenbereich";
    }
  }

  function enhanceLengthOptions() {
    document
      .querySelectorAll(".option-selector[data-option]")
      .forEach(function (group) {
        if (
          !isLengthOption(group) ||
          group.dataset.cardoriLengthReady === "true"
        ) {
          return;
        }

        var inputs = group.querySelectorAll('input[type="radio"].js-option');
        if (!inputs.length) return;

        group.dataset.cardoriLengthReady = "true";

        if (inputs.length === 1) {
          createSingleLengthRow(group, inputs[0], parseLength(inputs[0].value));
        } else {
          enhanceMultipleLengths(group, inputs);
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceLengthOptions, {
      once: true,
    });
  } else {
    enhanceLengthOptions();
  }

  new MutationObserver(enhanceLengthOptions).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* CARDORI adaptive variant labels: expand only grids whose text would be truncated */
(() => {
  const GRID_SELECTOR = '.template-product .option-selector__btns:has(.opt-label--swatch)';
  const COLUMN_CLASSES = [
    'cardori-option-labels-cols-1',
    'cardori-option-labels-cols-2',
    'cardori-option-labels-cols-3'
  ];
  let frame = 0;

  const updateGrid = (grid) => {
    COLUMN_CLASSES.forEach((className) => grid.classList.remove(className));

    if (window.innerWidth < 768) return;

    const labels = [...grid.querySelectorAll(':scope > .opt-label--swatch')];
    if (!labels.length) return;

    const gap = Number.parseFloat(getComputedStyle(grid).columnGap) || 8;
    const fourColumnWidth = (grid.clientWidth - gap * 3) / 4;
    const needsMoreSpace = labels.some((label) => {
      const value = label.querySelector('.js-value');
      if (!value) return false;

      const fixedContentWidth = label.clientWidth - value.clientWidth;
      const availableWidth = fourColumnWidth - fixedContentWidth;
      return value.scrollWidth > availableWidth + 1;
    });

    if (!needsMoreSpace) return;

    const columns = Math.min(3, labels.length);
    grid.classList.add(`cardori-option-labels-cols-${columns}`);
  };

  const updateAll = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll(GRID_SELECTOR).forEach(updateGrid);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('change', updateAll, true);
  window.addEventListener('resize', updateAll, { passive: true });
  new MutationObserver(updateAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* CARDORI adaptive variant labels: reliable fallback for visually truncated names */
(() => {
  const GRID_SELECTOR = '.template-product .option-selector__btns:has(.opt-label--swatch)';
  const COLUMN_CLASSES = [
    'cardori-option-labels-cols-1',
    'cardori-option-labels-cols-2',
    'cardori-option-labels-cols-3'
  ];
  let frame = 0;

  const updateGrid = (grid) => {
    if (window.innerWidth < 768) return;

    const labels = [...grid.querySelectorAll(':scope > .opt-label--swatch')];
    const values = labels
      .map((label) => label.querySelector('.js-value')?.textContent.trim() || '')
      .filter(Boolean);
    if (!values.length) return;

    const maxLength = Math.max(...values.map((value) => value.length));
    if (maxLength < 7) return;

    COLUMN_CLASSES.forEach((className) => grid.classList.remove(className));
    const columns = Math.min(maxLength >= 16 ? 2 : 3, labels.length);
    grid.classList.add(`cardori-option-labels-cols-${columns}`);
  };

  const updateAll = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll(GRID_SELECTOR).forEach(updateGrid);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('change', updateAll, true);
  window.addEventListener('resize', updateAll, { passive: true });
  new MutationObserver(updateAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
/* CARDORI smart variant grid: measures labels and adapts future option sets automatically */
(() => {
  const GRID_SELECTOR = '.template-product .option-selector__btns:has(.opt-label--swatch)';
  const MANAGED_CLASSES = [
    'cardori-option-labels-cols-1',
    'cardori-option-labels-cols-2',
    'cardori-option-labels-cols-3',
    'cardori-smart-cols-1',
    'cardori-smart-cols-2',
    'cardori-smart-cols-3',
    'cardori-smart-cols-4',
    'cardori-smart-auto',
    'cardori-smart-wrap',
    'cardori-smart-nowrap'
  ];
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  let frame = 0;

  const measureText = (element, text) => {
    const style = getComputedStyle(element);
    if (!context) return text.length * (Number.parseFloat(style.fontSize) || 15) * 0.55;
    context.font = [
      style.fontStyle,
      style.fontVariant,
      style.fontWeight,
      style.fontSize,
      style.fontFamily
    ].join(' ');
    const letterSpacing = Number.parseFloat(style.letterSpacing) || 0;
    return context.measureText(text).width + Math.max(0, text.length - 1) * letterSpacing;
  };

  const updateGrid = (grid) => {
    MANAGED_CLASSES.forEach((className) => grid.classList.remove(className));
    grid.style.removeProperty('grid-template-columns');

    if (window.innerWidth < 768) return;

    const labels = [...grid.querySelectorAll(':scope > .opt-label--swatch')];
    if (!labels.length) return;

    const gap = Number.parseFloat(getComputedStyle(grid).columnGap) || 8;
    const metrics = labels.map((label) => {
      const value = label.querySelector('.js-value');
      const text = value?.textContent.trim() || '';
      const labelWidth = label.getBoundingClientRect().width;
      const valueWidth = value?.getBoundingClientRect().width || 0;
      const fixedWidth = Math.max(42, labelWidth - valueWidth);
      const segments = text.split(/[\/\s-]+/).filter(Boolean);
      const longestSegment = segments.reduce((longest, segment) =>
        measureText(value || label, segment) > measureText(value || label, longest) ? segment : longest, '');
      return {
        full: measureText(value || label, text) + fixedWidth + 4,
        segment: measureText(value || label, longestSegment || text) + fixedWidth + 4
      };
    });

    const gridWidth = grid.clientWidth;
    const columnWidth = (columns) => (gridWidth - gap * (columns - 1)) / columns;
    const fullFits = (columns) => metrics.every((metric) => metric.full <= columnWidth(columns) + 1);
    const segmentFits = (columns) => metrics.every((metric) => metric.segment <= columnWidth(columns) + 1);

    let columns = Math.min(4, labels.length);
    let wrap = false;
    let auto = false;

    if (!fullFits(columns)) {
      const totalNaturalWidth = metrics.reduce((sum, metric) => sum + metric.full, 0) + gap * (labels.length - 1);

      if (labels.length <= 3 && totalNaturalWidth <= gridWidth) {
        auto = true;
      } else if (labels.length === 4 && fullFits(2)) {
        columns = 2;
      } else if (columns === 4 && segmentFits(4)) {
        wrap = true;
      } else {
        const candidates = labels.length === 4
          ? [2, 1]
          : [3, 2, 1].filter((candidate) => candidate < columns && candidate <= labels.length);
        const fullMatch = candidates.find(fullFits);
        if (fullMatch) {
          columns = fullMatch;
        } else {
          const wrapMatch = candidates.find(segmentFits);
          columns = wrapMatch || 1;
          wrap = Boolean(wrapMatch);
        }
      }
    }

    if (auto) {
      grid.classList.add('cardori-smart-auto', 'cardori-smart-nowrap');
      grid.style.gridTemplateColumns = metrics.map((metric) => `${Math.ceil(metric.full)}px`).join(' ');
    } else {
      grid.classList.add(`cardori-smart-cols-${columns}`);
      grid.classList.add(wrap ? 'cardori-smart-wrap' : 'cardori-smart-nowrap');
    }
  };

  const updateAll = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll(GRID_SELECTOR).forEach(updateGrid);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('change', updateAll, true);
  window.addEventListener('resize', updateAll, { passive: true });
  new MutationObserver(updateAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


/* CARDORI PILOT: upload guidance, consent and AI processing state - 2026-08-26 */
(function () {
  if (window.__cardoriPilotUploadExperience20260826) return;
  window.__cardoriPilotUploadExperience20260826 = true;

  const isPilotProduct = /\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(
    window.location.pathname
  );
  if (!isPilotProduct) return;

  const uploadValues = ["Fertige Vorlage", "Foto umwandeln"];
  const tooltipTexts = new Set([
    "Fertige Vorlage",
    "Foto umwandeln",
    "Text",
    "Eigenes Motiv",
    "Design wählen",
  ]);

  const readyExample = '';

  const photoExample = '';

  let refreshTimer = null;
  let doneTimer = null;

  function optionName(option) {
    const named = option.querySelector(".option_name");
    return String(named ? named.textContent : option.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function findOption(name) {
    return Array.from(
      document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option")
    ).find(function (option) {
      return optionName(option).startsWith(name);
    });
  }

  function isVisible(element) {
    return Boolean(element && element.offsetParent !== null);
  }

  function isOwnMotifSelected() {
    return Boolean(
      document.querySelector(
        ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][value="Handschrift / Bild"]:checked,' +
        ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][value="Bild / Handschrift"]:checked'
      )
    );
  }

  function selectedUploadRoute() {
    const input = document.querySelector(
      '.cardori-upload-choice input[type="radio"]:checked'
    );
    return input ? input.value : "";
  }

  function replaceButtonText(button, nextText) {
    if (!button) return;
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (textNode) {
      const text = String(textNode.nodeValue || "").trim();
      if (
        text === "FOTO AUSWÄHLEN" ||
        text === "FOTO WIRD VERARBEITET" ||
        text === "ANDERES FOTO WÄHLEN"
      ) {
        textNode.nodeValue = " " + nextText + " ";
      }
    });
  }

  function suppressDuplicateTooltips() {
    document
      .querySelectorAll(
        ".cardori-upload-choice [title]," +
        ".cardori-upload-choice [aria-describedby]," +
        ".cardori-engraving-style-option [title]"
      )
      .forEach(function (element) {
        element.removeAttribute("title");
        element.removeAttribute("aria-describedby");
        if (element._tippy && typeof element._tippy.destroy === "function") {
          element._tippy.destroy();
        }
      });

    document
      .querySelectorAll('[role="tooltip"], .tooltip, .tippy-box')
      .forEach(function (tooltip) {
        const text = String(tooltip.textContent || "").replace(/\s+/g, " ").trim();
        if (tooltipTexts.has(text)) tooltip.remove();
      });
  }

  function guideMarkup(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option) return;
    let guide = option.querySelector(":scope > .cardori-upload-guide");
    if (!guide) {
      guide = document.createElement("div");
      guide.className = "cardori-upload-guide";
      guide.dataset.cardoriGuideType = type;
      guide.innerHTML = guideMarkup(type);
      cardoriBindUploadExamples20261024(guide, option);
      option.appendChild(guide);
    }
  }

  function statusElement(option) {
    let status = option && option.querySelector(":scope > .cardori-ai-status");
    if (!status && option) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML =
        '<span class="cardori-ai-status__indicator" aria-hidden="true"></span>' +
        '<div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      const guide = option.querySelector(":scope > .cardori-upload-guide");
      option.insertBefore(status, guide || null);
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    const title = status.querySelector("strong");
    const copy = status.querySelector(".cardori-ai-status__copy span");
    const indicator = status.querySelector(".cardori-ai-status__indicator");
    status.hidden = false;
    status.classList.toggle("cardori-ai-status--processing", state === "processing");
    status.classList.toggle("cardori-ai-status--done", state === "done");
    if (state === "processing") {
      indicator.textContent = "";
      title.textContent = "Dein Foto wird vorbereitet …";
      copy.textContent =
        "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
    } else {
      indicator.textContent = "✓";
      title.textContent = "Deine Linienzeichnung ist fertig";
      copy.textContent = "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau.";
    }
  }

  function setLocked(element, locked) {
    if (!element) return;
    if (locked) {
      if (!element.dataset.cardoriOriginalDisabled) {
        element.dataset.cardoriOriginalDisabled = element.disabled ? "1" : "0";
      }
      element.disabled = true;
      element.setAttribute("aria-disabled", "true");
      element.classList.add("cardori-ai-locked");
    } else if (element.classList.contains("cardori-ai-locked")) {
      element.disabled = element.dataset.cardoriOriginalDisabled === "1";
      if (!element.disabled) element.removeAttribute("aria-disabled");
      element.classList.remove("cardori-ai-locked");
      delete element.dataset.cardoriOriginalDisabled;
    }
  }

  function consentCheckbox() {
    const injected = document.querySelector("#cardori-motif-rights-consent");
    if (injected) return injected;
    const existing = Array.from(
      document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type='checkbox']")
    ).find(function (input) {
      const option = input.closest(".customily_option");
      return option && /erforderlichen Rechte am Motiv/i.test(option.textContent || "");
    });
    return existing || null;
  }

  function ensureConsent(activeUploadOption) {
    let consent = document.querySelector(
      ".cardori-upload-consent--injected"
    );
    const shouldShow =
      isOwnMotifSelected() && selectedUploadRoute() && activeUploadOption;

    if (!shouldShow) {
      if (consent) consent.remove();
      return null;
    }

    const existing = consentCheckbox();
    if (existing && existing.id !== "cardori-motif-rights-consent") {
      const option = existing.closest(".customily_option");
      if (option) option.classList.add("cardori-upload-consent");
      return existing;
    }

    if (!consent) {
      consent = document.createElement("div");
      consent.className =
        "customily_option cardori-upload-consent--injected";
      consent.innerHTML =
        '<label class="cardori-upload-consent__label" for="cardori-motif-rights-consent">' +
          '<input id="cardori-motif-rights-consent" type="checkbox" name="properties[Motivrechte bestätigt]" value="Ja" required>' +
          '<span>Ich besitze die erforderlichen Rechte am Motiv und abgebildete Personen sind mit der Personalisierung einverstanden.</span>' +
        '</label>' +
        '<p class="cardori-upload-consent__help">Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.</p>' +
        '<p class="cardori-upload-consent__error">Bitte bestätige die erforderlichen Rechte am Motiv.</p>';
      consent.querySelector("input").addEventListener("change", function () {
        consent.classList.remove("cardori-upload-consent--invalid");
        queueRefresh();
      });
    }

    activeUploadOption.insertAdjacentElement("afterend", consent);
    return consent.querySelector("input");
  }

  function updatePurchaseGuards(processing, consent) {
    const needsConsent = Boolean(consent && !consent.checked);
    document
      .querySelectorAll(
        "#customily-cart-btn, button[name='add'], .product-form__submit"
      )
      .forEach(function (button) {
        setLocked(button, processing || needsConsent);
      });
    document
      .querySelectorAll("#customily-preview-button, .customily-preview-button")
      .forEach(function (button) {
        setLocked(button, processing);
      });
  }

  function refresh() {
    refreshTimer = null;
    suppressDuplicateTooltips();

    const readyOption = findOption("Vorlage gravieren");
    const photoOption = findOption("Foto umwandeln");
    if (readyOption) ensureGuide(readyOption, "ready");
    if (photoOption) ensureGuide(photoOption, "photo");

    const route = selectedUploadRoute();
    const activeUploadOption =
      route === "Fertige Vorlage"
        ? readyOption
        : route === "Foto umwandeln"
          ? photoOption
          : null;
    const consent = ensureConsent(activeUploadOption);

    const uploadButton = photoOption && photoOption.querySelector(
      "button.cardori-upload-button"
    );
    const processing = Boolean(
      uploadButton &&
      (uploadButton.disabled || uploadButton.classList.contains("disabled")) &&
      uploadButton.querySelector(".spinner-border")
    );

    if (photoOption && uploadButton) {
      const status = statusElement(photoOption);
      const wasProcessing =
        photoOption.dataset.cardoriWasProcessing === "true";

      if (processing) {
        window.clearTimeout(doneTimer);
        photoOption.dataset.cardoriWasProcessing = "true";
        replaceButtonText(uploadButton, "FOTO WIRD VERARBEITET");
        showStatus(status, "processing");
      } else if (wasProcessing) {
        photoOption.dataset.cardoriWasProcessing = "false";
        replaceButtonText(uploadButton, "ANDERES FOTO WÄHLEN");
        showStatus(status, "done");
        window.clearTimeout(doneTimer);
        doneTimer = window.setTimeout(function () {
          if (status) status.hidden = true;
        }, 12000);
      } else if (
        photoOption.querySelector("img") &&
        uploadButton.querySelector(".cl-icon-rotate")
      ) {
        replaceButtonText(uploadButton, "ANDERES FOTO WÄHLEN");
      }
    }

    document.body.classList.toggle("cardori-ai-processing", processing);
    updatePurchaseGuards(processing, consent);
  }

  function queueRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 70);
  }

  document.addEventListener(
    "click",
    function (event) {
      const locked = event.target.closest(".cardori-ai-locked");
      if (locked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const consent = document.querySelector(
          ".cardori-upload-consent--injected"
        );
        if (
          consent &&
          !document.body.classList.contains("cardori-ai-processing")
        ) {
          consent.classList.add("cardori-upload-consent--invalid");
          consent.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    },
    true
  );

  new MutationObserver(queueRefresh).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "disabled", "title", "aria-describedby"],
  });

  [
    "customily-options-loaded",
    "customily-options-changed",
    "customily-variation-change-finished",
  ].forEach(function (eventName) {
    window.addEventListener(eventName, queueRefresh);
  });

  window.setInterval(queueRefresh, 450);
  queueRefresh();
})();

console.info("[CARDORI-PILOT] probe", location.pathname, Boolean(window.__cardoriPilotUploadExperience20260826));
/* CARDORI PILOT: upload guidance, consent and AI processing state - 2026-08-26 */
(function () {
  if (window.__cardoriPilotUploadExperienceTheme20260826v2) return;
  window.__cardoriPilotUploadExperienceTheme20260826v2 = true;

  const isPilotProduct = /\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(
    window.location.pathname
  );
  if (!isPilotProduct) return;

  const uploadValues = ["Fertige Vorlage", "Foto umwandeln"];
  const tooltipTexts = new Set([
    "Fertige Vorlage",
    "Foto umwandeln",
    "Text",
    "Eigenes Motiv",
    "Design wählen",
  ]);

  const readyExample = '';

  const photoExample = '';

  let refreshTimer = null;
  let doneTimer = null;

  function optionName(option) {
    const named = option.querySelector(".option_name");
    return String(named ? named.textContent : option.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function findOption(name) {
    return Array.from(
      document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option")
    ).find(function (option) {
      return optionName(option).startsWith(name);
    });
  }

  function isVisible(element) {
    return Boolean(element && element.offsetParent !== null);
  }

  function isOwnMotifSelected() {
    return Boolean(
      document.querySelector(
        ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][value="Eigenes Motiv"]:checked,' +
        ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][value="Handschrift / Bild"]:checked,' +
        ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][value="Bild / Handschrift"]:checked'
      )
    );
  }

  function selectedUploadRoute() {
    const input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Was möchtest du hochladen?]"]:checked,' +
      '.cardori-upload-choice input[type="radio"]:checked'
    );
    return input ? input.value : "";
  }

  function replaceButtonText(button, nextText) {
    if (!button) return;
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (textNode) {
      const text = String(textNode.nodeValue || "").trim();
      if (
        text === "FOTO AUSWÄHLEN" ||
        text === "FOTO WIRD VERARBEITET" ||
        text === "ANDERES FOTO WÄHLEN"
      ) {
        textNode.nodeValue = " " + nextText + " ";
      }
    });
  }

  function suppressDuplicateTooltips() {
    document
      .querySelectorAll(
        ".cardori-upload-choice [title]," +
        ".cardori-upload-choice [aria-describedby]," +
        ".cardori-engraving-style-option [title]"
      )
      .forEach(function (element) {
        element.removeAttribute("title");
        element.removeAttribute("aria-describedby");
        if (element._tippy && typeof element._tippy.destroy === "function") {
          element._tippy.destroy();
        }
      });

    document
      .querySelectorAll('[role="tooltip"], .tooltip, .tippy-box')
      .forEach(function (tooltip) {
        const text = String(tooltip.textContent || "").replace(/\s+/g, " ").trim();
        if (tooltipTexts.has(text)) tooltip.remove();
      });
  }

  function guideMarkup(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option) return;
    let guide = option.querySelector(":scope > .cardori-upload-guide");
    if (!guide) {
      guide = document.createElement("div");
      guide.className = "cardori-upload-guide";
      guide.dataset.cardoriGuideType = type;
      guide.innerHTML = guideMarkup(type);
      cardoriBindUploadExamples20261024(guide, option);
      option.appendChild(guide);
    }
  }

  function statusElement(option) {
    let status = option && option.querySelector(":scope > .cardori-ai-status");
    if (!status && option) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML =
        '<span class="cardori-ai-status__indicator" aria-hidden="true"></span>' +
        '<div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      const guide = option.querySelector(":scope > .cardori-upload-guide");
      option.insertBefore(status, guide || null);
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    const title = status.querySelector("strong");
    const copy = status.querySelector(".cardori-ai-status__copy span");
    const indicator = status.querySelector(".cardori-ai-status__indicator");
    status.hidden = false;
    status.classList.toggle("cardori-ai-status--processing", state === "processing");
    status.classList.toggle("cardori-ai-status--done", state === "done");
    if (state === "processing") {
      indicator.textContent = "";
      title.textContent = "Dein Foto wird vorbereitet …";
      copy.textContent =
        "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
    } else {
      indicator.textContent = "✓";
      title.textContent = "Deine Linienzeichnung ist fertig";
      copy.textContent = "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau.";
    }
  }

  function setLocked(element, locked) {
    if (!element) return;
    if (locked) {
      if (!element.dataset.cardoriOriginalDisabled) {
        element.dataset.cardoriOriginalDisabled = element.disabled ? "1" : "0";
      }
      element.disabled = true;
      element.setAttribute("aria-disabled", "true");
      element.classList.add("cardori-ai-locked");
    } else if (element.classList.contains("cardori-ai-locked")) {
      element.disabled = element.dataset.cardoriOriginalDisabled === "1";
      if (!element.disabled) element.removeAttribute("aria-disabled");
      element.classList.remove("cardori-ai-locked");
      delete element.dataset.cardoriOriginalDisabled;
    }
  }

  function consentCheckbox() {
    const injected = document.querySelector("#cardori-motif-rights-consent");
    if (injected) return injected;
    const existing = Array.from(
      document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type='checkbox']")
    ).find(function (input) {
      const option = input.closest(".customily_option");
      return option && /erforderlichen Rechte am Motiv/i.test(option.textContent || "");
    });
    return existing || null;
  }

  function ensureConsent(activeUploadOption) {
    let consent = document.querySelector(
      ".cardori-upload-consent--injected"
    );
    const shouldShow =
      isOwnMotifSelected() && selectedUploadRoute() && activeUploadOption;

    if (!shouldShow) {
      if (consent) consent.remove();
      return null;
    }

    const existing = consentCheckbox();
    if (existing && existing.id !== "cardori-motif-rights-consent") {
      const option = existing.closest(".customily_option");
      if (option) option.classList.add("cardori-upload-consent");
      return existing;
    }

    if (!consent) {
      consent = document.createElement("div");
      consent.className =
        "customily_option cardori-upload-consent--injected";
      consent.innerHTML =
        '<label class="cardori-upload-consent__label" for="cardori-motif-rights-consent">' +
          '<input id="cardori-motif-rights-consent" type="checkbox" name="properties[Motivrechte bestätigt]" value="Ja" required>' +
          '<span>Ich besitze die erforderlichen Rechte am Motiv und abgebildete Personen sind mit der Personalisierung einverstanden.</span>' +
        '</label>' +
        '<p class="cardori-upload-consent__help">Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.</p>' +
        '<p class="cardori-upload-consent__error">Bitte bestätige die erforderlichen Rechte am Motiv.</p>';
      consent.querySelector("input").addEventListener("change", function () {
        consent.classList.remove("cardori-upload-consent--invalid");
        queueRefresh();
      });
    }

    activeUploadOption.insertAdjacentElement("afterend", consent);
    return consent.querySelector("input");
  }

  function updatePurchaseGuards(processing, consent) {
    const needsConsent = Boolean(consent && !consent.checked);
    document
      .querySelectorAll(
        "#customily-cart-btn, button[name='add'], .product-form__submit"
      )
      .forEach(function (button) {
        setLocked(button, processing || needsConsent);
      });
    document
      .querySelectorAll("#customily-preview-button, .customily-preview-button")
      .forEach(function (button) {
        setLocked(button, processing);
      });
  }

  function refresh() {
    refreshTimer = null;
    suppressDuplicateTooltips();

    const readyOption = findOption("Vorlage gravieren");
    const photoOption = findOption("Foto umwandeln");
    if (readyOption) ensureGuide(readyOption, "ready");
    if (photoOption) ensureGuide(photoOption, "photo");

    const route = selectedUploadRoute();
    const activeUploadOption =
      route === "Fertige Vorlage"
        ? readyOption
        : route === "Foto umwandeln"
          ? photoOption
          : null;
    const consent = ensureConsent(activeUploadOption);

    const uploadButton = photoOption && photoOption.querySelector(
      "button.cardori-upload-button"
    );
    const processing = Boolean(
      uploadButton &&
      (uploadButton.disabled || uploadButton.classList.contains("disabled")) &&
      uploadButton.querySelector(".spinner-border")
    );

    if (photoOption && uploadButton) {
      const status = statusElement(photoOption);
      const wasProcessing =
        photoOption.dataset.cardoriWasProcessing === "true";

      if (processing) {
        window.clearTimeout(doneTimer);
        photoOption.dataset.cardoriWasProcessing = "true";
        replaceButtonText(uploadButton, "FOTO WIRD VERARBEITET");
        showStatus(status, "processing");
      } else if (wasProcessing) {
        photoOption.dataset.cardoriWasProcessing = "false";
        replaceButtonText(uploadButton, "ANDERES FOTO WÄHLEN");
        showStatus(status, "done");
        window.clearTimeout(doneTimer);
        doneTimer = window.setTimeout(function () {
          if (status) status.hidden = true;
        }, 12000);
      } else if (
        photoOption.querySelector("img") &&
        uploadButton.querySelector(".cl-icon-rotate")
      ) {
        replaceButtonText(uploadButton, "ANDERES FOTO WÄHLEN");
      }
    }

    document.body.classList.toggle("cardori-ai-processing", processing);
    updatePurchaseGuards(processing, consent);
  }

  function queueRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 70);
  }

  document.addEventListener(
    "click",
    function (event) {
      const locked = event.target.closest(".cardori-ai-locked");
      if (locked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const consent = document.querySelector(
          ".cardori-upload-consent--injected"
        );
        if (
          consent &&
          !document.body.classList.contains("cardori-ai-processing")
        ) {
          consent.classList.add("cardori-upload-consent--invalid");
          consent.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    },
    true
  );

  new MutationObserver(queueRefresh).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  [
    "customily-options-loaded",
    "customily-options-changed",
    "customily-variation-change-finished",
  ].forEach(function (eventName) {
    window.addEventListener(eventName, queueRefresh);
  });

  window.setInterval(queueRefresh, 700);
  queueRefresh();
})();

console.info("[CARDORI-PILOT-V2] probe", Boolean(window.__cardoriPilotUploadExperienceTheme20260826v2));
setTimeout(function(){console.info("[CARDORI-PILOT-DBG]",document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option").length,Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option")).map(function(o){var n=o.querySelector(".option_name");return String(n?n.textContent:o.textContent).replace(/\s+/g," ").trim().slice(0,80)}));},6000);
/* CARDORI PILOT V3: clear upload guidance, consent and AI progress */
(function () {
  if (window.__cardoriPilotUploadExperienceTheme20260826v3) return;
  window.__cardoriPilotUploadExperienceTheme20260826v3 = true;

  if (!/\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(location.pathname)) return;

  var timer = 0;
  var wasProcessing = false;

  function clean(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function options() {
    return Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option"));
  }

  function findOption(title) {
    return options().find(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    }) || null;
  }

  function checkedValue(propertyName) {
    var input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[' + propertyName + ']\"]:checked'
    );
    return input ? input.value : "";
  }

  function guideHtml(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option || option.querySelector(":scope > .cardori-upload-guide")) return;
    var guide = document.createElement("div");
    guide.className = "cardori-upload-guide";
    guide.innerHTML = guideHtml(type);
    cardoriBindUploadExamples20261024(guide, option);
    option.appendChild(guide);
  }

  function suppressTooltips() {
    document.querySelectorAll(
      ".cardori-upload-choice [title], .cardori-upload-choice [aria-describedby], .cardori-engraving-style-option[title]"
    ).forEach(function (element) {
      element.removeAttribute("title");
      element.removeAttribute("aria-describedby");
      if (element._tippy && typeof element._tippy.destroy === "function") element._tippy.destroy();
    });
    document.querySelectorAll('[role="tooltip"], .tooltip, .tippy-box').forEach(function (tooltip) {
      if (/^(Fertige Vorlage|Foto umwandeln|Text|Eigenes Motiv|Design wählen)$/.test(clean(tooltip.textContent))) tooltip.remove();
    });
  }

  function ensureConsent(activeOption) {
    var existing = document.querySelector("#cardori-motif-rights-consent");
    if (!activeOption) {
      var old = document.querySelector(".cardori-upload-consent--injected");
      if (old) old.remove();
      return null;
    }
    if (!existing) {
      var consent = document.createElement("div");
      consent.className = "customily_option cardori-upload-consent--injected";
      consent.innerHTML = '<label class="cardori-upload-consent__label" for="cardori-motif-rights-consent"><input id="cardori-motif-rights-consent" type="checkbox" name="properties[Motivrechte bestätigt]" value="Ja" required><span>Ich besitze die erforderlichen Rechte am Motiv und abgebildete Personen sind mit der Personalisierung einverstanden.</span></label><p class="cardori-upload-consent__help">Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.</p><p class="cardori-upload-consent__error">Bitte bestätige die erforderlichen Rechte am Motiv.</p>';
      activeOption.insertAdjacentElement("afterend", consent);
      existing = consent.querySelector("input");
    }
    return existing;
  }

  function statusFor(option) {
    if (!option) return null;
    var status = option.querySelector(":scope > .cardori-ai-status");
    if (!status) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML = '<span class="cardori-ai-status__indicator" aria-hidden="true"></span><div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      option.insertBefore(status, option.querySelector(":scope > .cardori-upload-guide"));
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    status.hidden = false;
    status.className = "cardori-ai-status cardori-ai-status--" + state;
    status.querySelector(".cardori-ai-status__indicator").textContent = state === "done" ? "✓" : "";
    status.querySelector("strong").textContent = state === "done" ? "Deine Linienzeichnung ist fertig" : "Dein Foto wird vorbereitet …";
    status.querySelector(".cardori-ai-status__copy span").textContent = state === "done"
      ? "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau."
      : "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
  }

  function replaceUploadText(button, text) {
    if (!button) return;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && clean(node.nodeValue)) node.nodeValue = " " + text + " ";
    });
  }

  function lock(button, locked) {
    if (!button) return;
    if (locked) {
      if (!button.classList.contains("cardori-ai-locked")) {
        button.dataset.cardoriBeforeAiDisabled = String(button.disabled);
        button.dataset.cardoriBeforeAiAria = button.getAttribute("aria-disabled") || "";
      }
      button.classList.add("cardori-ai-locked");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else if (button.classList.contains("cardori-ai-locked")) {
      button.classList.remove("cardori-ai-locked");
      button.disabled = button.dataset.cardoriVariantUnavailable === "true" || button.dataset.cardoriBeforeAiDisabled === "true";
      if (!button.classList.contains("is-loading")) {
        if (button.dataset.cardoriBeforeAiAria) button.setAttribute("aria-disabled", button.dataset.cardoriBeforeAiAria);
        else button.removeAttribute("aria-disabled");
      }
      delete button.dataset.cardoriBeforeAiDisabled;
      delete button.dataset.cardoriBeforeAiAria;
    }
  }

  function refresh() {
    try {
      suppressTooltips();
      var ready = findOption("Vorlage gravieren");
      var photo = findOption("Foto umwandeln") || findOption("Foto als Liniengravur");
      ensureGuide(ready, "ready");
      ensureGuide(photo, "photo");

      var ownMotif = checkedValue("Gravur gestalten") === "Eigenes Motiv";
      var route = checkedValue("Was möchtest du hochladen?");
      var active = ownMotif && route === "Fertige Vorlage" ? ready : ownMotif && route === "Foto umwandeln" ? photo : null;
      var consent = ensureConsent(active);

      var upload = photo && photo.querySelector("button.cardori-upload-button, button.customily-download-button");
      var processing = Boolean(upload && upload.querySelector(".spinner-border") && (upload.disabled || upload.classList.contains("disabled")));
      var status = statusFor(photo);
      if (processing) {
        wasProcessing = true;
        replaceUploadText(upload, "FOTO WIRD VERARBEITET");
        showStatus(status, "processing");
      } else if (wasProcessing) {
        wasProcessing = false;
        replaceUploadText(upload, "ANDERES FOTO WÄHLEN");
        showStatus(status, "done");
      }

      var needsConsent = Boolean(consent && !consent.checked);
      document.querySelectorAll("#customily-cart-btn, button[name='add'], .product-form__submit").forEach(function (button) {
        lock(button, processing || needsConsent);
      });
      document.querySelectorAll("#customily-preview-button, .customily-preview-button").forEach(function (button) {
        lock(button, processing);
      });
    } catch (error) {
      console.error("[CARDORI PILOT V3]", error);
    }
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 90);
  }

  document.addEventListener("change", queue, true);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(queue, 700);
  queue();
})();


console.info("[CARDORI-PILOT-V3] probe", Boolean(window.__cardoriPilotUploadExperienceTheme20260826v3));
/* CARDORI PILOT V3: clear upload guidance, consent and AI progress */
(function () {
  return;

  var timer = 0;
  var wasProcessing = false;

  function clean(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function options() {
    return Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option"));
  }

  function findOption(title) {
    return options().find(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    }) || null;
  }

  function checkedValue(propertyName) {
    var input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[' + propertyName + ']\"]:checked'
    );
    return input ? input.value : "";
  }

  function guideHtml(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option || option.querySelector(":scope > .cardori-upload-guide")) return;
    var guide = document.createElement("div");
    guide.className = "cardori-upload-guide";
    guide.innerHTML = guideHtml(type);
    cardoriBindUploadExamples20261024(guide, option);
    option.appendChild(guide);
  }

  function suppressTooltips() {
    document.querySelectorAll(
      ".cardori-upload-choice [title], .cardori-upload-choice [aria-describedby], .cardori-engraving-style-option[title]"
    ).forEach(function (element) {
      element.removeAttribute("title");
      element.removeAttribute("aria-describedby");
      if (element._tippy && typeof element._tippy.destroy === "function") element._tippy.destroy();
    });
    document.querySelectorAll('[role="tooltip"], .tooltip, .tippy-box').forEach(function (tooltip) {
      if (/^(Fertige Vorlage|Foto umwandeln|Text|Eigenes Motiv|Design wählen)$/.test(clean(tooltip.textContent))) tooltip.remove();
    });
  }

  function ensureConsent(activeOption) {
    var existing = document.querySelector("#cardori-motif-rights-consent");
    if (!activeOption) {
      var old = document.querySelector(".cardori-upload-consent--injected");
      if (old) old.remove();
      return null;
    }
    if (!existing) {
      var consent = document.createElement("div");
      consent.className = "customily_option cardori-upload-consent--injected";
      consent.innerHTML = '<label class="cardori-upload-consent__label" for="cardori-motif-rights-consent"><input id="cardori-motif-rights-consent" type="checkbox" name="properties[Motivrechte bestätigt]" value="Ja" required><span>Ich besitze die erforderlichen Rechte am Motiv und abgebildete Personen sind mit der Personalisierung einverstanden.</span></label><p class="cardori-upload-consent__help">Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.</p><p class="cardori-upload-consent__error">Bitte bestätige die erforderlichen Rechte am Motiv.</p>';
      activeOption.insertAdjacentElement("afterend", consent);
      existing = consent.querySelector("input");
    }
    return existing;
  }

  function statusFor(option) {
    if (!option) return null;
    var status = option.querySelector(":scope > .cardori-ai-status");
    if (!status) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML = '<span class="cardori-ai-status__indicator" aria-hidden="true"></span><div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      option.insertBefore(status, option.querySelector(":scope > .cardori-upload-guide"));
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    status.hidden = false;
    status.className = "cardori-ai-status cardori-ai-status--" + state;
    status.querySelector(".cardori-ai-status__indicator").textContent = state === "done" ? "✓" : "";
    status.querySelector("strong").textContent = state === "done" ? "Deine Linienzeichnung ist fertig" : "Dein Foto wird vorbereitet …";
    status.querySelector(".cardori-ai-status__copy span").textContent = state === "done"
      ? "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau."
      : "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
  }

  function replaceUploadText(button, text) {
    if (!button) return;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && clean(node.nodeValue)) node.nodeValue = " " + text + " ";
    });
  }

  function lock(button, locked) {
    if (!button) return;
    if (locked) {
      if (!button.classList.contains("cardori-ai-locked")) {
        button.dataset.cardoriBeforeAiDisabled = String(button.disabled);
        button.dataset.cardoriBeforeAiAria = button.getAttribute("aria-disabled") || "";
      }
      button.classList.add("cardori-ai-locked");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else if (button.classList.contains("cardori-ai-locked")) {
      button.classList.remove("cardori-ai-locked");
      button.disabled = button.dataset.cardoriVariantUnavailable === "true" || button.dataset.cardoriBeforeAiDisabled === "true";
      if (!button.classList.contains("is-loading")) {
        if (button.dataset.cardoriBeforeAiAria) button.setAttribute("aria-disabled", button.dataset.cardoriBeforeAiAria);
        else button.removeAttribute("aria-disabled");
      }
      delete button.dataset.cardoriBeforeAiDisabled;
      delete button.dataset.cardoriBeforeAiAria;
    }
  }

  function refresh() {
    if (!location.pathname.includes("/products/coin-halskette-mit-gravur")) return;
    try {
      suppressTooltips();
      var ready = findOption("Vorlage gravieren");
      var photo = findOption("Foto umwandeln") || findOption("Foto als Liniengravur");
      ensureGuide(ready, "ready");
      ensureGuide(photo, "photo");

      var ownMotif = checkedValue("Gravur gestalten") === "Eigenes Motiv";
      var route = checkedValue("Was möchtest du hochladen?");
      var active = ownMotif && route === "Fertige Vorlage" ? ready : ownMotif && route === "Foto umwandeln" ? photo : null;
      var consent = ensureConsent(active);

      var upload = photo && photo.querySelector("button.cardori-upload-button, button.customily-download-button");
      var processing = Boolean(upload && upload.querySelector(".spinner-border") && (upload.disabled || upload.classList.contains("disabled")));
      var status = statusFor(photo);
      if (processing) {
        wasProcessing = true;
        replaceUploadText(upload, "FOTO WIRD VERARBEITET");
        showStatus(status, "processing");
      } else if (wasProcessing) {
        wasProcessing = false;
        replaceUploadText(upload, "ANDERES FOTO WÄHLEN");
        showStatus(status, "done");
      }

      var needsConsent = Boolean(consent && !consent.checked);
      document.querySelectorAll("#customily-cart-btn, button[name='add'], .product-form__submit").forEach(function (button) {
        lock(button, processing || needsConsent);
      });
      document.querySelectorAll("#customily-preview-button, .customily-preview-button").forEach(function (button) {
        lock(button, processing);
      });
    } catch (error) {
      console.error("[CARDORI PILOT V3]", error);
    }
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 90);
  }

  document.addEventListener("change", queue, true);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(queue, 700);
  queue();
})();


/* CARDORI PILOT V3: clear upload guidance, consent and AI progress */
(function () {
  return;

  var timer = 0;
  var wasProcessing = false;

  function clean(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function options() {
    return Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option"));
  }

  function findOption(title) {
    return options().find(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    }) || null;
  }

  function checkedValue(propertyName) {
    var input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[' + propertyName + ']\"]:checked'
    );
    return input ? input.value : "";
  }

  function guideHtml(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option || option.querySelector(":scope > .cardori-upload-guide")) return;
    var guide = document.createElement("div");
    guide.className = "cardori-upload-guide";
    guide.innerHTML = guideHtml(type);
    cardoriBindUploadExamples20261024(guide, option);
    option.appendChild(guide);
  }

  function suppressTooltips() {
    document.querySelectorAll(
      ".cardori-upload-choice [title], .cardori-upload-choice [aria-describedby], .cardori-engraving-style-option[title]"
    ).forEach(function (element) {
      element.removeAttribute("title");
      element.removeAttribute("aria-describedby");
      if (element._tippy && typeof element._tippy.destroy === "function") element._tippy.destroy();
    });
    document.querySelectorAll('[role="tooltip"], .tooltip, .tippy-box').forEach(function (tooltip) {
      if (/^(Fertige Vorlage|Foto umwandeln|Text|Eigenes Motiv|Design wählen)$/.test(clean(tooltip.textContent))) tooltip.remove();
    });
  }

  function ensureConsent(activeOption) {
    var existing = document.querySelector("#cardori-motif-rights-consent");
    if (!activeOption) {
      var old = document.querySelector(".cardori-upload-consent--injected");
      if (old) old.remove();
      return null;
    }
    if (!existing) {
      var consent = document.createElement("div");
      consent.className = "customily_option cardori-upload-consent--injected";
      consent.innerHTML = '<label class="cardori-upload-consent__label" for="cardori-motif-rights-consent"><input id="cardori-motif-rights-consent" type="checkbox" name="properties[Motivrechte bestätigt]" value="Ja" required><span>Ich besitze die erforderlichen Rechte am Motiv und abgebildete Personen sind mit der Personalisierung einverstanden.</span></label><p class="cardori-upload-consent__help">Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.</p><p class="cardori-upload-consent__error">Bitte bestätige die erforderlichen Rechte am Motiv.</p>';
      activeOption.insertAdjacentElement("afterend", consent);
      existing = consent.querySelector("input");
    }
    return existing;
  }

  function statusFor(option) {
    if (!option) return null;
    var status = option.querySelector(":scope > .cardori-ai-status");
    if (!status) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML = '<span class="cardori-ai-status__indicator" aria-hidden="true"></span><div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      option.insertBefore(status, option.querySelector(":scope > .cardori-upload-guide"));
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    status.hidden = false;
    status.className = "cardori-ai-status cardori-ai-status--" + state;
    status.querySelector(".cardori-ai-status__indicator").textContent = state === "done" ? "✓" : "";
    status.querySelector("strong").textContent = state === "done" ? "Deine Linienzeichnung ist fertig" : "Dein Foto wird vorbereitet …";
    status.querySelector(".cardori-ai-status__copy span").textContent = state === "done"
      ? "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau."
      : "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
  }

  function replaceUploadText(button, text) {
    if (!button) return;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && clean(node.nodeValue)) node.nodeValue = " " + text + " ";
    });
  }

  function lock(button, locked) {
    if (!button) return;
    if (locked) {
      if (!button.classList.contains("cardori-ai-locked")) {
        button.dataset.cardoriBeforeAiDisabled = String(button.disabled);
        button.dataset.cardoriBeforeAiAria = button.getAttribute("aria-disabled") || "";
      }
      button.classList.add("cardori-ai-locked");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else if (button.classList.contains("cardori-ai-locked")) {
      button.classList.remove("cardori-ai-locked");
      button.disabled = button.dataset.cardoriVariantUnavailable === "true" || button.dataset.cardoriBeforeAiDisabled === "true";
      if (!button.classList.contains("is-loading")) {
        if (button.dataset.cardoriBeforeAiAria) button.setAttribute("aria-disabled", button.dataset.cardoriBeforeAiAria);
        else button.removeAttribute("aria-disabled");
      }
      delete button.dataset.cardoriBeforeAiDisabled;
      delete button.dataset.cardoriBeforeAiAria;
    }
  }

  function refresh() {
    timer = 0;
    if (!location.pathname.includes("/products/coin-halskette-mit-gravur")) return;
    try {
      suppressTooltips();
      var ready = findOption("Vorlage gravieren");
      var photo = findOption("Foto umwandeln") || findOption("Foto als Liniengravur");
      ensureGuide(ready, "ready");
      ensureGuide(photo, "photo");

      var ownMotif = checkedValue("Gravur gestalten") === "Eigenes Motiv";
      var route = checkedValue("Was möchtest du hochladen?");
      var active = ownMotif && route === "Fertige Vorlage" ? ready : ownMotif && route === "Foto umwandeln" ? photo : null;
      var consent = ensureConsent(active);

      var upload = photo && photo.querySelector("button.cardori-upload-button, button.customily-download-button");
      var processing = Boolean(upload && upload.querySelector(".spinner-border") && (upload.disabled || upload.classList.contains("disabled")));
      var status = statusFor(photo);
      if (processing) {
        wasProcessing = true;
        replaceUploadText(upload, "FOTO WIRD VERARBEITET");
        showStatus(status, "processing");
      } else if (wasProcessing) {
        wasProcessing = false;
        replaceUploadText(upload, "ANDERES FOTO WÄHLEN");
        showStatus(status, "done");
      }

      var needsConsent = Boolean(consent && !consent.checked);
      document.querySelectorAll("#customily-cart-btn, button[name='add'], .product-form__submit").forEach(function (button) {
        lock(button, processing || needsConsent);
      });
      document.querySelectorAll("#customily-preview-button, .customily-preview-button").forEach(function (button) {
        lock(button, processing);
      });
    } catch (error) {
      console.error("[CARDORI PILOT V3]", error);
    }
  }

  function queue() {
    if (timer) return;
    timer = setTimeout(refresh, 90);
  }

  document.addEventListener("change", queue, true);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(queue, 700);
  queue();
})();


/* CARDORI PILOT FINAL V7 2026-08-26: progressive upload guidance, visible consent validation and AI status */
(function () {
  if (window.__cardoriPilotUploadExperienceTheme20260826v7) return;
  window.__cardoriPilotUploadExperienceTheme20260826v7 = true;

  if (!/\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(location.pathname)) return;

  var timer = 0;
  var engravingSelector = [
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name^="properties[Gravurstil"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design auswählen]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur Rückseite gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design Rückseite auswählen]"]'
  ].join(",");
  var fontSelector = ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name*="[Schriftart]"]';

  function clean(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function options() {
    return Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option"));
  }

  function findOption(title) {
    return options().find(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    }) || null;
  }

  function findOptions(title) {
    return options().filter(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    });
  }

  function checkedValue(propertyName) {
    var input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[' + propertyName + ']\"]:checked'
    );
    return input ? input.value : "";
  }

  function guideHtml(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option || option.querySelector(":scope > .cardori-upload-guide")) return;
    var guide = document.createElement("div");
    guide.className = "cardori-upload-guide";
    guide.innerHTML = guideHtml(type);
    cardoriBindUploadExamples20261024(guide, option);
    option.appendChild(guide);
  }

  function suppressTooltips() {
    document.querySelectorAll(
      ".cardori-upload-choice [title], .cardori-upload-choice [aria-describedby], .cardori-engraving-style-option[title]"
    ).forEach(function (element) {
      element.removeAttribute("title");
      element.removeAttribute("aria-describedby");
      if (element._tippy && typeof element._tippy.destroy === "function") element._tippy.destroy();
    });
    document.querySelectorAll('[role="tooltip"], .tooltip, .tippy-box').forEach(function (tooltip) {
      if (/^(Fertige Vorlage|Foto umwandeln|Text|Eigenes Motiv|Design wählen)$/.test(clean(tooltip.textContent))) tooltip.remove();
    });
  }

  function removeCountClasses(group) {
    Array.from(group.classList).forEach(function (className) {
      if (className.indexOf("cardori-count-") === 0) group.classList.remove(className);
    });
  }

  function applyCountClass(group) {
    var count = group.querySelectorAll('input[type="radio"]').length;
    var nextClass = count >= 1 && count <= 8 ? "cardori-count-" + count : "cardori-count-many";
    if (!group.classList.contains(nextClass)) {
      removeCountClasses(group);
      group.classList.add(nextClass);
    }
  }

  function makeWholeCardClickable(swatch, input, label) {
    if (swatch.dataset.cardoriPilotCardClickBound === "true") return;
    swatch.addEventListener("click", function (event) {
      if (event.target === input || event.target.closest("label")) return;
      label.click();
    });
    swatch.dataset.cardoriPilotCardClickBound = "true";
  }

  function neutralizeLabelBorder(label) {
    [["border", "0px"], ["outline", "0px"], ["box-shadow", "none"]].forEach(function (entry) {
      if (label.style.getPropertyValue(entry[0]) !== entry[1] || label.style.getPropertyPriority(entry[0]) !== "important") {
        label.style.setProperty(entry[0], entry[1], "important");
      }
    });
  }

  function ensureEngravingCaption(swatch, input) {
    var caption = swatch.querySelector(":scope > .cardori-style-caption");
    if (!caption) {
      caption = document.createElement("span");
      caption.className = "cardori-style-caption";
      caption.setAttribute("aria-hidden", "true");
      swatch.appendChild(caption);
    }
    var title = caption.querySelector(".cardori-style-title");
    if (!title) {
      title = document.createElement("span");
      title.className = "cardori-style-title";
      caption.insertBefore(title, caption.firstChild);
    }
    if (title.textContent !== input.value) title.textContent = input.value;
  }

  function decorateEngravingAndFontCards() {
    var engravingGroups = new Set();
    document.querySelectorAll(engravingSelector).forEach(function (input) {
      var swatch = input.closest(".customily-swatch");
      var group = input.closest('[role="radiogroup"]');
      var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      if (!swatch || !group || !label) return;
      engravingGroups.add(group);
      if (!group.classList.contains("cardori-engraving-style-group")) group.classList.add("cardori-engraving-style-group");
      if (!swatch.classList.contains("cardori-engraving-style-option")) swatch.classList.add("cardori-engraving-style-option");
      swatch.classList.toggle("is-selected", input.checked);
      neutralizeLabelBorder(label);
      ensureEngravingCaption(swatch, input);
      makeWholeCardClickable(swatch, input, label);
    });
    engravingGroups.forEach(applyCountClass);

    document.querySelectorAll(fontSelector).forEach(function (input) {
      var swatch = input.closest(".customily-swatch");
      var group = input.closest('[role="radiogroup"]');
      var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      if (!swatch || !group || !label) return;
      if (!group.classList.contains("cardori-font-style-group")) group.classList.add("cardori-font-style-group");
      if (!swatch.classList.contains("cardori-font-style-option")) swatch.classList.add("cardori-font-style-option");
      swatch.classList.toggle("is-selected", input.checked);
      neutralizeLabelBorder(label);
      makeWholeCardClickable(swatch, input, label);
    });
  }

  function decorateUploadChoiceCards() {
    document.querySelectorAll(".cardori-upload-choice .customily-swatch").forEach(function (swatch) {
      var input = swatch.querySelector('input[type="radio"]');
      var label = swatch.querySelector("label");
      if (!input || !label) return;
      swatch.classList.toggle("is-selected", input.checked);
      makeWholeCardClickable(swatch, input, label);
    });
  }

  function resizeTextareas() {
    document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) textarea").forEach(function (textarea) {
      textarea.style.setProperty("height", "54px", "important");
      var height = Math.max(54, Math.min(textarea.scrollHeight || 54, 152));
      textarea.classList.add("cardori-autogrow-field");
      textarea.style.setProperty("height", height + "px", "important");
      textarea.style.setProperty("overflow-y", (textarea.scrollHeight || 0) > 152 ? "auto" : "hidden", "important");
      if (textarea.dataset.cardoriPilotAutogrowBound !== "true") {
        textarea.addEventListener("input", queue);
        textarea.dataset.cardoriPilotAutogrowBound = "true";
      }
    });
  }

  function findNativeConsent() {
    var inputs = Array.from(document.querySelectorAll(':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="checkbox"]')).filter(function (input) {
      return input.name && input.name.indexOf("properties[Ich besitze die erforderlichen Rechte") === 0 && input.getClientRects().length;
    });
    return inputs.find(function (input) { return !input.checked; }) || inputs[0] || null;
  }

  function anyOwnMotifSelected() {
    return checkedValue("Gravur gestalten") === "Eigenes Motiv" ||
      checkedValue("Gravur Rückseite gestalten") === "Eigenes Motiv";
  }

  function ensureConsent(isNeeded) {
    var injected = document.querySelector(".cardori-upload-consent--injected");
    var nativeConsent = findNativeConsent();

    if (!isNeeded) {
      if (injected) injected.remove();
      return null;
    }

    if (nativeConsent) {
      if (injected) injected.remove();
      var nativeOption = nativeConsent.closest(".customily_option");
      if (nativeOption) {
        nativeOption.classList.add("cardori-upload-consent", "cardori-upload-consent--native");
        var nativeHelp = nativeOption.querySelector(".help-text");
        if (nativeHelp) {
          var helpHtml = 'Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.';
          if (nativeHelp.innerHTML !== helpHtml) nativeHelp.innerHTML = helpHtml;
        }
        var nativeError = nativeOption.querySelector(":scope > .cardori-upload-consent__error");
        if (!nativeError) {
          nativeError = document.createElement("p");
          nativeError.className = "cardori-upload-consent__error";
          nativeError.textContent = "Bitte noch bestätigen.";
          nativeOption.appendChild(nativeError);
        }
        nativeOption.classList.toggle("cardori-upload-consent--invalid", nativeOption.classList.contains("cardori-upload-consent--invalid") && !nativeConsent.checked);
      }
      return nativeConsent;
    }
    return null;
  }

  function clearConsentError(consent) {
    var option = consent && consent.closest(".customily_option");
    if (option) option.classList.remove("cardori-upload-consent--invalid", "cardori-upload-consent--attention");
  }

  function showConsentError(consent) {
    if (!consent) return;
    var option = consent.closest(".customily_option");
    if (!option) return;
    option.classList.add("cardori-upload-consent--invalid", "cardori-upload-consent--attention");
    var error = option.querySelector(":scope > .cardori-upload-consent__error");
    if (error) error.textContent = "Bitte noch bestätigen.";
    option.scrollIntoView({ behavior: "smooth", block: "center" });
    try { consent.focus({ preventScroll: true }); } catch (focusError) { consent.focus(); }
    window.setTimeout(function () {
      option.classList.remove("cardori-upload-consent--attention");
    }, 900);
  }

  function statusFor(option) {
    if (!option) return null;
    var status = option.querySelector(":scope > .cardori-ai-status");
    if (!status) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML = '<span class="cardori-ai-status__indicator" aria-hidden="true"></span><div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      option.insertBefore(status, option.querySelector(":scope > .cardori-upload-guide"));
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    status.hidden = false;
    status.className = "cardori-ai-status cardori-ai-status--" + state;
    status.querySelector(".cardori-ai-status__indicator").textContent = state === "done" ? "✓" : "";
    status.querySelector("strong").textContent = state === "done" ? "Deine Linienzeichnung ist fertig" : "Dein Foto wird gerade verarbeitet …";
    status.querySelector(".cardori-ai-status__copy span").textContent = state === "done"
      ? "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau."
      : "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
  }

  function replaceUploadText(button, text) {
    if (!button) return;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && clean(node.nodeValue)) node.nodeValue = " " + text + " ";
    });
  }

  function lock(button, locked) {
    if (!button) return;
    if (locked) {
      if (!button.classList.contains("cardori-ai-locked")) {
        button.dataset.cardoriBeforeAiDisabled = String(button.disabled);
        button.dataset.cardoriBeforeAiAria = button.getAttribute("aria-disabled") || "";
      }
      button.classList.add("cardori-ai-locked");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else if (button.classList.contains("cardori-ai-locked")) {
      button.classList.remove("cardori-ai-locked");
      button.disabled = button.dataset.cardoriVariantUnavailable === "true" || button.dataset.cardoriBeforeAiDisabled === "true";
      if (!button.classList.contains("is-loading")) {
        if (button.dataset.cardoriBeforeAiAria) button.setAttribute("aria-disabled", button.dataset.cardoriBeforeAiAria);
        else button.removeAttribute("aria-disabled");
      }
      delete button.dataset.cardoriBeforeAiDisabled;
      delete button.dataset.cardoriBeforeAiAria;
    }
  }

  function refresh() {
    timer = 0;
    try {
      suppressTooltips();
      decorateEngravingAndFontCards();
      decorateUploadChoiceCards();
      resizeTextareas();
      var readyOptions = findOptions("Vorlage gravieren");
      var photoOptions = findOptions("Foto umwandeln");
      if (!photoOptions.length) photoOptions = findOptions("Foto als Liniengravur");
      readyOptions.forEach(function (option) { ensureGuide(option, "ready"); });
      photoOptions.forEach(function (option) { ensureGuide(option, "photo"); });

      var consent = ensureConsent(anyOwnMotifSelected());
      if (consent && consent.checked) clearConsentError(consent);

      var processing = false;
      photoOptions.forEach(function (photo) {
        var upload = photo.querySelector("button.cardori-upload-button, button.customily-download-button");
        var optionProcessing = Boolean(upload && upload.querySelector(".spinner-border") && (upload.disabled || upload.classList.contains("disabled")));
        var status = statusFor(photo);
        if (optionProcessing) {
          processing = true;
          photo.dataset.cardoriWasProcessing = "true";
          replaceUploadText(upload, "FOTO WIRD VERARBEITET");
          showStatus(status, "processing");
        } else if (photo.dataset.cardoriWasProcessing === "true") {
          delete photo.dataset.cardoriWasProcessing;
          replaceUploadText(upload, "ANDERES FOTO WÄHLEN");
          showStatus(status, "done");
        }
      });

      document.querySelectorAll("#customily-cart-btn, button[name='add'], .product-form__submit").forEach(function (button) {
        lock(button, processing);
      });
      document.querySelectorAll("#customily-preview-button, .customily-preview-button").forEach(function (button) {
        lock(button, processing);
      });
    } catch (error) {
      console.error("[CARDORI PILOT FINAL V7]", error);
    }
  }

  function queue() {
    if (timer) return;
    timer = setTimeout(refresh, 90);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("#customily-cart-btn, button[name='add'], .product-form__submit, :is(.customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) button[aria-label='Next options']");
    if (!button || !anyOwnMotifSelected()) return;
    var consent = findNativeConsent();
    if (!consent || !consent.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (consent) showConsentError(consent);
      else {
        queue();
        window.setTimeout(function () {
          var renderedConsent = findNativeConsent();
          if (renderedConsent) showConsentError(renderedConsent);
        }, 160);
      }
    }
  }, true);
  document.addEventListener("change", function (event) {
    if (event.target.matches('input[type="checkbox"]') && event.target.name.indexOf("properties[Ich besitze die erforderlichen Rechte am Motiv") === 0 && event.target.checked) clearConsentError(event.target);
    queue();
  }, true);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(queue, 700);
  queue();
})();

/* CARDORI PILOT DYNAMIC PRICES V2 2026-08-26: linked Customily products and second-image advantage */
(function () {
  if (window.__cardoriPilotDynamicPrices20260826v2) return;
  window.__cardoriPilotDynamicPrices20260826v2 = true;

  if (!/\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(location.pathname)) return;

  var configurationRequest = null;
  var productRequests = new Map();
  var renderTimer = 0;
  var engravingSelector = [
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name^="properties[Gravurstil"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design auswählen]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur Rückseite gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design Rückseite auswählen]"]'
  ].join(",");

  function asArray(value) {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  function clean(value) {
    return String(value || "")
      .replace(/\s*\(\s*\+\s*\d+(?:[.,]\d{1,2})?\s*€\s*\)\s*$/i, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalized(value) {
    return clean(value).toLocaleLowerCase("de-DE");
  }

  function isImageValue(value) {
    var name = normalized(value);
    return name === "eigenes motiv" || name === "bild" || name.includes("handschrift") || name.includes("bildgravur");
  }

  function isRearInput(input) {
    var name = String(input && input.name || "");
    return name.includes("[Gravurstil Rückseite]") || name.includes("[Gravur Rückseite gestalten]");
  }

  function currentProductHandle() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function currentProductId() {
    var form = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(function (item) {
      return item.getAttribute("data-product-id");
    });
    return form ? form.getAttribute("data-product-id") : "";
  }

  function loadConfiguration() {
    if (configurationRequest) return configurationRequest;
    var handle = currentProductHandle();
    var productId = currentProductId();
    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "cardoris.myshopify.com";
    if (!handle || !productId) return Promise.reject(new Error("Customily product identity unavailable"));

    configurationRequest = fetch(
      "https://sh.customily.com/api/settings/unified/" + encodeURIComponent(handle) +
      "?shop=" + encodeURIComponent(shop) + "&productId=" + encodeURIComponent(productId),
      { credentials: "omit", headers: { Accept: "application/json" }, cache: "no-store" }
    ).then(function (response) {
      if (!response.ok) throw new Error("Customily configuration unavailable");
      return response.json();
    }).catch(function (error) {
      configurationRequest = null;
      throw error;
    });
    return configurationRequest;
  }

  function inputIdentity(input) {
    var match = String(input.id || "").match(/^cl-set-(.+)-cl-option-(\d+)(?:-cl-value-id-\d+)?$/);
    return match ? { setId: match[1], optionId: match[2] } : null;
  }

  function configuredOption(configuration, input) {
    var identity = inputIdentity(input);
    if (!identity) return null;
    var set = asArray(configuration && configuration.sets).find(function (item) {
      return String(item.id) === String(identity.setId);
    });
    return asArray(set && set.options).find(function (item) {
      return String(item.id) === String(identity.optionId);
    }) || null;
  }

  function linkedProductsForInput(input, option) {
    if (!option) return [];
    var functions = asArray(option.functions).filter(function (item) {
      return item && item.type === "shProduct";
    });
    if (input.type === "checkbox") {
      return functions.reduce(function (products, item) {
        return products.concat(asArray(item.shProducts));
      }, []);
    }
    var selectedValue = asArray(option.values).find(function (item) {
      return clean(item && item.value) === clean(input.value);
    });
    return asArray(selectedValue && selectedValue.shProducts);
  }

  function linkedProductsForSetHandle(configuration, setId, handle) {
    var set = asArray(configuration && configuration.sets).find(function (item) {
      return String(item.id) === String(setId);
    });
    return asArray(set && set.options).reduce(function (products, option) {
      return products.concat(asArray(option && option.functions).filter(function (item) {
        return item && item.type === "shProduct";
      }).reduce(function (items, item) {
        return items.concat(asArray(item.shProducts));
      }, []));
    }, []).filter(function (product) {
      return product && product.handle === handle;
    });
  }

  function loadProduct(handle) {
    if (productRequests.has(handle)) return productRequests.get(handle);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    var request = fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin", headers: { Accept: "application/json" }, cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Linked Shopify product unavailable");
      return response.json();
    });
    productRequests.set(handle, request);
    return request;
  }

  function linkedPrice(products) {
    return Promise.all(products.map(function (linkedProduct) {
      if (!linkedProduct || !linkedProduct.handle || !linkedProduct.variantId) return 0;
      return loadProduct(linkedProduct.handle).then(function (product) {
        var variant = asArray(product.variants).find(function (item) {
          return String(item.id) === String(linkedProduct.variantId);
        });
        return variant ? Number(variant.price || 0) * Number(linkedProduct.quantity || 1) : 0;
      });
    })).then(function (prices) {
      return prices.reduce(function (total, price) { return total + price; }, 0);
    });
  }

  function formatPrice(cents) {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
  }

  function ensureStylePrice(input) {
    var swatch = input.closest(".customily-swatch");
    if (!swatch) return null;
    var caption = swatch.querySelector(":scope > .cardori-style-caption");
    if (!caption) return null;
    var price = caption.querySelector(":scope > .cardori-style-price");
    if (!price) {
      price = document.createElement("span");
      price.className = "cardori-style-price";
      caption.appendChild(price);
    }
    return price;
  }

  // Oval: keep first image at full price and show the other side at the second-image price.
  let ovalFirstImageSide = null;
  function ovalImagePriceState() {
    const priceSet = {"oval-schlusselanhanger-mit-gravur-handschrift-gravur":"1a893188-6601-48cc-b238-5e84a88feec6","rechteck-schlusselanhanger-mit-gravur":"d7d9dd2d-2af6-4fb7-8f55-5657b4fe15f7"}[currentProductHandle()];
    if (!priceSet) return null;
    const prefix = "#cl-set-" + priceSet + "-cl-option-";
    const front = document.querySelector(prefix + '100-cl-value-id-2');
    const rear = document.querySelector(prefix + '300-cl-value-id-2');
    const enabled = document.querySelector(prefix + '19');
    const f = Boolean(front && front.checked);
    const r = Boolean(enabled && enabled.checked && rear && rear.checked);
    if (!f && !r) ovalFirstImageSide = null;
    else if (f && !r) ovalFirstImageSide = "front";
    else if (r && !f) ovalFirstImageSide = "rear";
    else if (!ovalFirstImageSide) ovalFirstImageSide = "front";
    return {front:f, rear:r, first:ovalFirstImageSide};
  }

  function renderStylePrices(configuration) {
    const ovalPrices = ovalImagePriceState();
    document.querySelectorAll(engravingSelector).forEach(function (input) {
      var priceElement = ensureStylePrice(input);
      var group = input.closest('[role="radiogroup"]');
      if (!priceElement || !group) return;

      var identity = inputIdentity(input);
      var products = linkedProductsForInput(input, configuredOption(configuration, input));
      var compareProducts = [];
      if (isRearInput(input) && isImageValue(input.value)) {
        var frontImageSelected = Array.from(document.querySelectorAll(
          ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravurstil]"]:checked,' +
          ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]:checked'
        )).some(function (frontInput) { return isImageValue(frontInput.value); });
        products = linkedProductsForSetHandle(configuration, identity && identity.setId, frontImageSelected ? "zweite-bildgravur" : "bildgravur");
        if (frontImageSelected) compareProducts = linkedProductsForSetHandle(configuration, identity && identity.setId, "bildgravur");
      }

        if (ovalPrices && isImageValue(input.value)) {
          const identity = inputIdentity(input);
          if (identity && ["1a893188-6601-48cc-b238-5e84a88feec6","d7d9dd2d-2af6-4fb7-8f55-5657b4fe15f7"].includes(identity.setId) &&
              ["100", "300"].includes(identity.optionId)) {
            const rearCard = identity.optionId === "300";
            const otherSelected = rearCard ? ovalPrices.front : ovalPrices.rear;
            const thisSelected = rearCard ? ovalPrices.rear : ovalPrices.front;
            const thisSide = rearCard ? "rear" : "front";
            const discounted = otherSelected && (!thisSelected || ovalPrices.first !== thisSide);
            products = linkedProductsForSetHandle(configuration, identity.setId,
              discounted ? "zweite-bildgravur" : "bildgravur");
            compareProducts = discounted
              ? linkedProductsForSetHandle(configuration, identity.setId, "bildgravur") : [];
          }
        }

      var key = products.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|") + "|compare:" + compareProducts.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|");

      priceElement.replaceChildren();
      priceElement.classList.remove("cardori-style-price--discount");
      priceElement.removeAttribute("aria-label");
      priceElement.setAttribute("data-cardori-products", key);
      if (!products.length) return;

      Promise.all([linkedPrice(products), compareProducts.length ? linkedPrice(compareProducts) : Promise.resolve(0)]).then(function (prices) {
        if (priceElement.getAttribute("data-cardori-products") !== key || prices[0] <= 0) return;
        var current = "+" + formatPrice(prices[0]);
        if (prices[1] > prices[0]) {
          var oldPrice = document.createElement("s");
          var currentPrice = document.createElement("span");
          oldPrice.className = "cardori-style-price-old";
          currentPrice.className = "cardori-style-price-current";
          oldPrice.textContent = "+" + formatPrice(prices[1]);
          currentPrice.textContent = current;
          priceElement.classList.add("cardori-style-price--discount");
          priceElement.setAttribute("aria-label", "Jetzt " + current + ", statt " + oldPrice.textContent);
          priceElement.append(oldPrice, currentPrice);
        } else {
          priceElement.textContent = current;
        }
        group.classList.add("cardori-group-has-price");
      }).catch(function () {
        priceElement.replaceChildren();
      });
    });
  }

  function ensureCheckboxPrice(container) {
    var price = container.querySelector(":scope > .cardori-upprice-text");
    if (!price) {
      price = document.createElement("small");
      price.className = "help-text cardori-upprice-text";
      container.insertBefore(price, container.querySelector(":scope > .bottom-spacer") || null);
    }
    return price;
  }

  function renderCheckboxPrices(configuration) {
    document.querySelectorAll(':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="checkbox"]').forEach(function (input) {
      var container = input.closest(".cl-option-content");
      if (!container) return;
      var products = linkedProductsForInput(input, configuredOption(configuration, input));
      var oldPrice = container.querySelector(":scope > .cardori-upprice-text");
      if (!products.length) {
        container.classList.remove("cardori-upprice-option");
        if (oldPrice) oldPrice.remove();
        return;
      }
      container.classList.add("cardori-upprice-option");
      var price = ensureCheckboxPrice(container);
      var key = products.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|");
      price.textContent = "";
      price.setAttribute("data-cardori-products", key);
      linkedPrice(products).then(function (cents) {
        if (cents > 0 && price.getAttribute("data-cardori-products") === key) price.textContent = "(+" + formatPrice(cents) + ")";
      }).catch(function () { price.textContent = ""; });
    });
  }

  function render() {
    renderTimer = 0;
    document.querySelectorAll(engravingSelector).forEach(ensureStylePrice);
    document.documentElement.setAttribute("data-cardori-price-status", "loading");
    loadConfiguration().then(function (configuration) {
      document.documentElement.setAttribute("data-cardori-price-status", "ready");
      renderStylePrices(configuration);
      renderCheckboxPrices(configuration);
    }).catch(function (error) {
      document.documentElement.setAttribute("data-cardori-price-status", "error");
      console.warn("CARDORI PILOT: linked prices unavailable", error);
    });
  }

  function queue() {
    if (renderTimer) return;
    renderTimer = window.setTimeout(render, 120);
  }

  document.addEventListener("change", queue, true);
  window.addEventListener("customily-options-loaded", queue);
  window.addEventListener("customily-options-changed", queue);
  window.addEventListener("customily-variation-change-finished", queue);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();

/* CARDORI mobile sticky live-preview bridge – 2026-08-27 v10 */
(function () {
  "use strict";

  if (window.__cardoriMobileStickyLivePreview20260827v10) return;
  window.__cardoriMobileStickyLivePreview20260827v10 = true;

  var mobileQuery = window.matchMedia("(max-width: 767px)");
  var activeClass = "cardori-sticky-live-preview";
  var frameRequested = false;

  function clean(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function looksLikePreviewControl(element) {
    if (!element || element.matches(".cardori-preview-return, #cardori-preview-return")) {
      return false;
    }

    var label = clean(element.getAttribute("aria-label"));
    var text = clean(element.textContent);
    var candidates = [label, text];

    return candidates.some(function (candidate) {
      return candidate === "vorschau" ||
        candidate === "preview" ||
        candidate === "gravurvorschau" ||
        candidate === "gravurvorschau ansehen";
    });
  }

  function isFloatingControl(element) {
    if (!mobileQuery.matches || !element) return false;

    var node = element;
    var depth = 0;

    while (node && node !== document.body && depth < 7) {
      var style = window.getComputedStyle(node);
      var descriptor = clean(
        (typeof node.className === "string" ? node.className : "") + " " + (node.id || "")
      );

      if (style.position === "fixed") return true;

      if (style.position === "sticky" && (
        node === element || /sticky|floating|fixed|bottom[-_ ]?bar|mobile[-_ ]?preview/.test(descriptor)
      )) {
        return true;
      }

      if (/sticky|floating|fixed|bottom[-_ ]?bar|mobile[-_ ]?preview/.test(descriptor) &&
          (style.position === "fixed" || style.position === "sticky")) {
        return true;
      }

      node = node.parentElement;
      depth += 1;
    }

    return false;
  }

  function hasExactStickyPreviewLabel(element) {
    if (!mobileQuery.matches || !element ||
        element.matches(".cardori-preview-return, #cardori-preview-return")) {
      return false;
    }

    return clean(element.textContent) === "vorschau" ||
      clean(element.getAttribute("aria-label")) === "vorschau";
  }

  function setLivePreviewMode(element, enabled) {
    if (enabled) {
      if (element.classList.contains(activeClass)) return;

      if (!element.dataset.cardoriOriginalAriaLabel) {
        element.dataset.cardoriOriginalAriaLabel = element.getAttribute("aria-label") || "__none__";
      }

      element.classList.add(activeClass);
      element.setAttribute("aria-label", "Zur Live-Vorschau");
      element.setAttribute("title", "Zur Live-Vorschau");
      return;
    }

    if (!element.classList.contains(activeClass)) return;

    element.classList.remove(activeClass);
    var original = element.dataset.cardoriOriginalAriaLabel;
    if (original === "__none__") element.removeAttribute("aria-label");
    else if (original) element.setAttribute("aria-label", original);
    element.removeAttribute("title");
    delete element.dataset.cardoriOriginalAriaLabel;
  }

  function syncFloatingPreviewControls() {
    frameRequested = false;

    document.querySelectorAll('button, a, [role="button"]').forEach(function (element) {
      var enabled = hasExactStickyPreviewLabel(element) ||
        (looksLikePreviewControl(element) && isFloatingControl(element));
      setLivePreviewMode(element, enabled);
    });
  }

  function queueSync() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(syncFloatingPreviewControls);
  }

  function showLivePreview() {
    var existingReturnButton = document.getElementById("cardori-preview-return");

    if (existingReturnButton) {
      existingReturnButton.click();
      return;
    }

    var preview = document.querySelector(".cl-canvas-container");
    if (!preview) return;

    preview.style.removeProperty("display");
    if (window.getComputedStyle(preview).display === "none") {
      preview.style.display = "flex";
    }

    window.requestAnimationFrame(function () {
      preview.scrollIntoView({ behavior: "auto", block: "center" });
    });
  }

  document.addEventListener("click", function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var control = target && target.closest("button, a, [role='button']");
    if (!control) return;

    if (!control.classList.contains(activeClass)) {
      var shouldActivate = hasExactStickyPreviewLabel(control) ||
        (looksLikePreviewControl(control) && isFloatingControl(control));
      setLivePreviewMode(control, shouldActivate);
    }

    if (!control.classList.contains(activeClass)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showLivePreview();
  }, true);

  window.addEventListener("scroll", queueSync, { passive: true });
  window.addEventListener("resize", queueSync, { passive: true });
  window.addEventListener("customily-live-preview-shown", queueSync);

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", queueSync);
  }

  document.addEventListener("DOMContentLoaded", queueSync);

  if (document.documentElement) {
    new MutationObserver(queueSync).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "aria-label"]
    });
  }

  queueSync();
})();

/* CARDORI: keep visible personalization card captions in sync with Customily values. */
(function () {
  "use strict";

  if (window.__cardoriOptionLabelSync20260827) return;
  window.__cardoriOptionLabelSync20260827 = true;

  var scheduled = false;

  function syncLabels() {
    scheduled = false;

    document
      .querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .cardori-engraving-style-option")
      .forEach(function (swatch) {
        var input = swatch.querySelector('input[type="radio"]');
        var title = swatch.querySelector(":scope > .cardori-style-caption .cardori-style-title");

        if (!input || !title) return;

        var nextLabel = String(input.value || "").trim();
        if (nextLabel && title.textContent.trim() !== nextLabel) {
          title.textContent = nextLabel;
        }
      });
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncLabels);
  }

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["value"]
  });

  document.addEventListener("change", scheduleSync, true);
  document.addEventListener("customily:change", scheduleSync, true);
  scheduleSync();
})();


/* CARDORI GLOBAL PERSONALIZER V8 2026-08-29: reusable cards, consent and AI status */
(function () {
  if (window.__cardoriGlobalPersonalizer20260829v8) return;
  window.__cardoriGlobalPersonalizer20260829v8 = true;

  if (!location.pathname.includes("/products/")) return;
  if (/\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(location.pathname)) return;

  var timer = 0;
  var engravingSelector = [
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name^="properties[Gravurstil"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design auswählen]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur Rückseite gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design Rückseite auswählen]"]'
  ].join(",");
  var fontSelector = ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name*="[Schriftart]"]';

  function clean(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function options() {
    return Array.from(document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) .customily_option"));
  }

  function findOption(title) {
    return options().find(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    }) || null;
  }

  function findOptions(title) {
    return options().filter(function (option) {
      var name = option.querySelector(":scope > label .option_name");
      return clean(name ? name.textContent : option.textContent).startsWith(title);
    });
  }

  function checkedValue(propertyName) {
    var input = document.querySelector(
      ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[' + propertyName + ']\"]:checked'
    );
    return input ? input.value : "";
  }

  function guideHtml(type) { return cardoriUploadGuideMarkup20261024(type); }

  function ensureGuide(option, type) {
    if (!option || option.querySelector(":scope > .cardori-upload-guide")) return;
    var guide = document.createElement("div");
    guide.className = "cardori-upload-guide";
    guide.innerHTML = guideHtml(type);
    cardoriBindUploadExamples20261024(guide, option);
    option.appendChild(guide);
  }

  function suppressTooltips() {
    document.querySelectorAll(
      ".cardori-upload-choice [title], .cardori-upload-choice [aria-describedby], .cardori-engraving-style-option[title]"
    ).forEach(function (element) {
      element.removeAttribute("title");
      element.removeAttribute("aria-describedby");
      if (element._tippy && typeof element._tippy.destroy === "function") element._tippy.destroy();
    });
    document.querySelectorAll('[role="tooltip"], .tooltip, .tippy-box').forEach(function (tooltip) {
      if (/^(Fertige Vorlage|Foto umwandeln|Text|Eigenes Motiv|Design wählen)$/.test(clean(tooltip.textContent))) tooltip.remove();
    });
  }

  function removeCountClasses(group) {
    Array.from(group.classList).forEach(function (className) {
      if (className.indexOf("cardori-count-") === 0) group.classList.remove(className);
    });
  }

  function applyCountClass(group) {
    var count = group.querySelectorAll('input[type="radio"]').length;
    var nextClass = count >= 1 && count <= 8 ? "cardori-count-" + count : "cardori-count-many";
    if (!group.classList.contains(nextClass)) {
      removeCountClasses(group);
      group.classList.add(nextClass);
    }
  }

  function makeWholeCardClickable(swatch, input, label) {
    if (swatch.dataset.cardoriPilotCardClickBound === "true") return;
    swatch.addEventListener("click", function (event) {
      if (event.target === input || event.target.closest("label")) return;
      label.click();
    });
    swatch.dataset.cardoriPilotCardClickBound = "true";
  }

  function neutralizeLabelBorder(label) {
    [["border", "0px"], ["outline", "0px"], ["box-shadow", "none"]].forEach(function (entry) {
      if (label.style.getPropertyValue(entry[0]) !== entry[1] || label.style.getPropertyPriority(entry[0]) !== "important") {
        label.style.setProperty(entry[0], entry[1], "important");
      }
    });
  }

  function ensureEngravingCaption(swatch, input) {
    var caption = swatch.querySelector(":scope > .cardori-style-caption");
    if (!caption) {
      caption = document.createElement("span");
      caption.className = "cardori-style-caption";
      caption.setAttribute("aria-hidden", "true");
      swatch.appendChild(caption);
    }
    var title = caption.querySelector(".cardori-style-title");
    if (!title) {
      title = document.createElement("span");
      title.className = "cardori-style-title";
      caption.insertBefore(title, caption.firstChild);
    }
    if (title.textContent !== input.value) title.textContent = input.value;
  }

  function decorateEngravingAndFontCards() {
    var engravingGroups = new Set();
    document.querySelectorAll(engravingSelector).forEach(function (input) {
      var swatch = input.closest(".customily-swatch");
      var group = input.closest('[role="radiogroup"]');
      var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      if (!swatch || !group || !label) return;
      engravingGroups.add(group);
      if (!group.classList.contains("cardori-engraving-style-group")) group.classList.add("cardori-engraving-style-group");
      if (!swatch.classList.contains("cardori-engraving-style-option")) swatch.classList.add("cardori-engraving-style-option");
      swatch.classList.toggle("is-selected", input.checked);
      neutralizeLabelBorder(label);
      ensureEngravingCaption(swatch, input);
      makeWholeCardClickable(swatch, input, label);
    });
    engravingGroups.forEach(applyCountClass);

    document.querySelectorAll(fontSelector).forEach(function (input) {
      var swatch = input.closest(".customily-swatch");
      var group = input.closest('[role="radiogroup"]');
      var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      if (!swatch || !group || !label) return;
      if (!group.classList.contains("cardori-font-style-group")) group.classList.add("cardori-font-style-group");
      if (!swatch.classList.contains("cardori-font-style-option")) swatch.classList.add("cardori-font-style-option");
      swatch.classList.toggle("is-selected", input.checked);
      neutralizeLabelBorder(label);
      makeWholeCardClickable(swatch, input, label);
    });
  }

  function decorateUploadChoiceCards() {
    document.querySelectorAll(".cardori-upload-choice .customily-swatch").forEach(function (swatch) {
      var input = swatch.querySelector('input[type="radio"]');
      var label = swatch.querySelector("label");
      if (!input || !label) return;
      swatch.classList.toggle("is-selected", input.checked);
      makeWholeCardClickable(swatch, input, label);
    });
  }

  function resizeTextareas() {
    document.querySelectorAll(":is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) textarea").forEach(function (textarea) {
      textarea.style.setProperty("height", "54px", "important");
      var height = Math.max(54, Math.min(textarea.scrollHeight || 54, 152));
      textarea.classList.add("cardori-autogrow-field");
      textarea.style.setProperty("height", height + "px", "important");
      textarea.style.setProperty("overflow-y", (textarea.scrollHeight || 0) > 152 ? "auto" : "hidden", "important");
      if (textarea.dataset.cardoriPilotAutogrowBound !== "true") {
        textarea.addEventListener("input", queue);
        textarea.dataset.cardoriPilotAutogrowBound = "true";
      }
    });
  }

  function findNativeConsent() {
    return Array.from(document.querySelectorAll(':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="checkbox"]')).find(function (input) {
      return input.name && input.name.indexOf("properties[Ich besitze die erforderlichen Rechte") === 0;
    }) || null;
  }

  function anyOwnMotifSelected() {
    return Array.from(document.querySelectorAll(engravingSelector)).some(function (input) {
      if (!input.checked) return false;
      var value = clean(input.value).toLocaleLowerCase("de-DE");
      return value === "eigenes motiv" || value === "bild" || value.indexOf("handschrift") >= 0 || value.indexOf("bildgravur") >= 0;
    });
  }

  function ensureConsent(isNeeded) {
    var injected = document.querySelector(".cardori-upload-consent--injected");
    var nativeConsent = findNativeConsent();

    if (!isNeeded) {
      if (injected) injected.remove();
      return null;
    }

    if (nativeConsent) {
      if (injected) injected.remove();
      var nativeOption = nativeConsent.closest(".customily_option");
      if (nativeOption) {
        nativeOption.classList.add("cardori-upload-consent", "cardori-upload-consent--native");
        var nativeHelp = nativeOption.querySelector(".help-text");
        if (nativeHelp) {
          var helpHtml = 'Dein Bild wird nur für deine Personalisierung verarbeitet. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Mehr zum Datenschutz</a>.';
          if (nativeHelp.innerHTML !== helpHtml) nativeHelp.innerHTML = helpHtml;
        }
        var nativeError = nativeOption.querySelector(":scope > .cardori-upload-consent__error");
        if (!nativeError) {
          nativeError = document.createElement("p");
          nativeError.className = "cardori-upload-consent__error";
          nativeError.textContent = "Bitte noch bestätigen.";
          nativeOption.appendChild(nativeError);
        }
        nativeOption.classList.toggle("cardori-upload-consent--invalid", nativeOption.classList.contains("cardori-upload-consent--invalid") && !nativeConsent.checked);
      }
      return nativeConsent;
    }
    return null;
  }

  function clearConsentError(consent) {
    var option = consent && consent.closest(".customily_option");
    if (option) option.classList.remove("cardori-upload-consent--invalid", "cardori-upload-consent--attention");
  }

  function showConsentError(consent) {
    if (!consent) return;
    var option = consent.closest(".customily_option");
    if (!option) return;
    option.classList.add("cardori-upload-consent--invalid", "cardori-upload-consent--attention");
    var error = option.querySelector(":scope > .cardori-upload-consent__error");
    if (error) error.textContent = "Bitte noch bestätigen.";
    option.scrollIntoView({ behavior: "smooth", block: "center" });
    try { consent.focus({ preventScroll: true }); } catch (focusError) { consent.focus(); }
    window.setTimeout(function () {
      option.classList.remove("cardori-upload-consent--attention");
    }, 900);
  }

  function statusFor(option) {
    if (!option) return null;
    var status = option.querySelector(":scope > .cardori-ai-status");
    if (!status) {
      status = document.createElement("div");
      status.className = "cardori-ai-status";
      status.hidden = true;
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.innerHTML = '<span class="cardori-ai-status__indicator" aria-hidden="true"></span><div class="cardori-ai-status__copy"><strong></strong><span></span></div>';
      option.insertBefore(status, option.querySelector(":scope > .cardori-upload-guide"));
    }
    return status;
  }

  function showStatus(status, state) {
    if (!status) return;
    status.hidden = false;
    status.className = "cardori-ai-status cardori-ai-status--" + state;
    status.querySelector(".cardori-ai-status__indicator").textContent = state === "done" ? "✓" : "";
    status.querySelector("strong").textContent = state === "done" ? "Deine Linienzeichnung ist fertig" : "Dein Foto wird gerade verarbeitet …";
    status.querySelector(".cardori-ai-status__copy span").textContent = state === "done"
      ? "Bitte prüfe jetzt das Ergebnis in der Gravurvorschau."
      : "Wir erstellen eine gravierbare Linienzeichnung. Das kann etwa 30–60 Sekunden dauern. Bitte bleib kurz auf dieser Seite.";
  }

  function replaceUploadText(button, text) {
    if (!button) return;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && clean(node.nodeValue)) node.nodeValue = " " + text + " ";
    });
  }

  function lock(button, locked) {
    if (!button) return;
    if (locked) {
      if (!button.classList.contains("cardori-ai-locked")) {
        button.dataset.cardoriBeforeAiDisabled = String(button.disabled);
        button.dataset.cardoriBeforeAiAria = button.getAttribute("aria-disabled") || "";
      }
      button.classList.add("cardori-ai-locked");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else if (button.classList.contains("cardori-ai-locked")) {
      button.classList.remove("cardori-ai-locked");
      button.disabled = button.dataset.cardoriVariantUnavailable === "true" || button.dataset.cardoriBeforeAiDisabled === "true";
      if (!button.classList.contains("is-loading")) {
        if (button.dataset.cardoriBeforeAiAria) button.setAttribute("aria-disabled", button.dataset.cardoriBeforeAiAria);
        else button.removeAttribute("aria-disabled");
      }
      delete button.dataset.cardoriBeforeAiDisabled;
      delete button.dataset.cardoriBeforeAiAria;
    }
  }

  function refresh() {
    timer = 0;
    try {
      suppressTooltips();
      decorateEngravingAndFontCards();
      decorateUploadChoiceCards();
      resizeTextareas();
      var readyOptions = findOptions("Vorlage gravieren");
      findOptions("Fertige Vorlage").forEach(function (option) { if (readyOptions.indexOf(option) < 0) readyOptions.push(option); });
      var photoOptions = findOptions("Foto umwandeln");
      if (!photoOptions.length) photoOptions = findOptions("Foto als Liniengravur");
      readyOptions.forEach(function (option) { ensureGuide(option, "ready"); });
      photoOptions.forEach(function (option) { ensureGuide(option, "photo"); });

      var consent = ensureConsent(anyOwnMotifSelected());
      if (consent && consent.checked) clearConsentError(consent);

      var processing = false;
      photoOptions.forEach(function (photo) {
        var upload = photo.querySelector("button.cardori-upload-button, button.customily-download-button");
        var optionProcessing = Boolean(upload && upload.querySelector(".spinner-border") && (upload.disabled || upload.classList.contains("disabled")));
        var status = statusFor(photo);
        if (optionProcessing) {
          processing = true;
          photo.dataset.cardoriWasProcessing = "true";
          replaceUploadText(upload, "FOTO WIRD VERARBEITET");
          showStatus(status, "processing");
        } else if (photo.dataset.cardoriWasProcessing === "true") {
          delete photo.dataset.cardoriWasProcessing;
          replaceUploadText(upload, "ANDERES FOTO WÄHLEN");
          showStatus(status, "done");
        }
      });

      document.querySelectorAll("#customily-cart-btn, button[name='add'], .product-form__submit").forEach(function (button) {
        lock(button, processing);
      });
      document.querySelectorAll("#customily-preview-button, .customily-preview-button").forEach(function (button) {
        lock(button, processing);
      });
    } catch (error) {
      console.error("[CARDORI GLOBAL PERSONALIZER V8]", error);
    }
  }

  function queue() {
    if (timer) return;
    timer = setTimeout(refresh, 90);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("#customily-cart-btn, button[name='add'], .product-form__submit");
    if (!button || !anyOwnMotifSelected()) return;
    var consent = findNativeConsent();
    if (!consent || !consent.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (consent) showConsentError(consent);
      else {
        queue();
        window.setTimeout(function () {
          var renderedConsent = findNativeConsent();
          if (renderedConsent) showConsentError(renderedConsent);
        }, 160);
      }
    }
  }, true);
  document.addEventListener("change", function (event) {
    if (event.target === findNativeConsent() && event.target.checked) clearConsentError(event.target);
    queue();
  }, true);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(queue, 700);
  queue();
})();



/* CARDORI GLOBAL DYNAMIC PRICES V3 2026-08-29: linked Customily products and second-image advantage */
(function () {
  if (window.__cardoriGlobalDynamicPrices20260829v3) return;
  window.__cardoriGlobalDynamicPrices20260829v3 = true;

  if (!location.pathname.includes("/products/")) return;
  if (/\/products\/coin-halskette-mit-gravur(?:\/|$)/.test(location.pathname)) return;

  var configurationRequest = null;
  var productRequests = new Map();
  var renderTimer = 0;
  var engravingSelector = [
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name^="properties[Gravurstil"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design auswählen]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur Rückseite gestalten]"]',
    ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Design Rückseite auswählen]"]'
  ].join(",");

  function asArray(value) {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  function clean(value) {
    return String(value || "")
      .replace(/\s*\(\s*\+\s*\d+(?:[.,]\d{1,2})?\s*€\s*\)\s*$/i, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalized(value) {
    return clean(value).toLocaleLowerCase("de-DE");
  }

  function isImageValue(value) {
    var name = normalized(value);
    return name === "eigenes motiv" || name === "bild" || name.includes("handschrift") || name.includes("bildgravur");
  }

  function isRearInput(input) {
    var name = String(input && input.name || "");
    return name.includes("[Gravurstil Rückseite]") || name.includes("[Gravur Rückseite gestalten]");
  }

  function currentProductHandle() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function currentProductId() {
    var form = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(function (item) {
      return item.getAttribute("data-product-id");
    });
    return form ? form.getAttribute("data-product-id") : "";
  }

  function loadConfiguration() {
    if (configurationRequest) return configurationRequest;
    var handle = currentProductHandle();
    var productId = currentProductId();
    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "cardoris.myshopify.com";
    if (!handle || !productId) return Promise.reject(new Error("Customily product identity unavailable"));

    configurationRequest = fetch(
      "https://sh.customily.com/api/settings/unified/" + encodeURIComponent(handle) +
      "?shop=" + encodeURIComponent(shop) + "&productId=" + encodeURIComponent(productId),
      { credentials: "omit", headers: { Accept: "application/json" }, cache: "no-store" }
    ).then(function (response) {
      if (!response.ok) throw new Error("Customily configuration unavailable");
      return response.json();
    }).catch(function (error) {
      configurationRequest = null;
      throw error;
    });
    return configurationRequest;
  }

  function inputIdentity(input) {
    var match = String(input.id || "").match(/^cl-set-(.+)-cl-option-(\d+)(?:-cl-value-id-\d+)?$/);
    return match ? { setId: match[1], optionId: match[2] } : null;
  }

  function configuredOption(configuration, input) {
    var identity = inputIdentity(input);
    if (!identity) return null;
    var set = asArray(configuration && configuration.sets).find(function (item) {
      return String(item.id) === String(identity.setId);
    });
    return asArray(set && set.options).find(function (item) {
      return String(item.id) === String(identity.optionId);
    }) || null;
  }

  function linkedProductsForInput(input, option) {
    if (!option) return [];
    var functions = asArray(option.functions).filter(function (item) {
      return item && item.type === "shProduct";
    });
    if (input.type === "checkbox") {
      return functions.reduce(function (products, item) {
        return products.concat(asArray(item.shProducts));
      }, []);
    }
    var selectedValue = asArray(option.values).find(function (item) {
      return clean(item && item.value) === clean(input.value);
    });
    return asArray(selectedValue && selectedValue.shProducts);
  }

  function linkedProductsForSetHandle(configuration, setId, handle) {
    var set = asArray(configuration && configuration.sets).find(function (item) {
      return String(item.id) === String(setId);
    });
    return asArray(set && set.options).reduce(function (products, option) {
      return products.concat(asArray(option && option.functions).filter(function (item) {
        return item && item.type === "shProduct";
      }).reduce(function (items, item) {
        return items.concat(asArray(item.shProducts));
      }, []));
    }, []).filter(function (product) {
      return product && product.handle === handle;
    });
  }

  function loadProduct(handle) {
    if (productRequests.has(handle)) return productRequests.get(handle);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    var request = fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin", headers: { Accept: "application/json" }, cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Linked Shopify product unavailable");
      return response.json();
    });
    productRequests.set(handle, request);
    return request;
  }

  function linkedPrice(products) {
    return Promise.all(products.map(function (linkedProduct) {
      if (!linkedProduct || !linkedProduct.handle || !linkedProduct.variantId) return 0;
      return loadProduct(linkedProduct.handle).then(function (product) {
        var variant = asArray(product.variants).find(function (item) {
          return String(item.id) === String(linkedProduct.variantId);
        });
        return variant ? Number(variant.price || 0) * Number(linkedProduct.quantity || 1) : 0;
      });
    })).then(function (prices) {
      return prices.reduce(function (total, price) { return total + price; }, 0);
    });
  }

  function formatPrice(cents) {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
  }

  function ensureStylePrice(input) {
    var swatch = input.closest(".customily-swatch");
    if (!swatch) return null;
    var caption = swatch.querySelector(":scope > .cardori-style-caption");
    if (!caption) return null;
    var price = caption.querySelector(":scope > .cardori-style-price");
    if (!price) {
      price = document.createElement("span");
      price.className = "cardori-style-price";
      caption.appendChild(price);
    }
    return price;
  }

  // Oval: keep first image at full price and show the other side at the second-image price.
  let ovalFirstImageSide = null;
  function ovalImagePriceState() {
    const priceSet = {"oval-schlusselanhanger-mit-gravur-handschrift-gravur":"1a893188-6601-48cc-b238-5e84a88feec6","rechteck-schlusselanhanger-mit-gravur":"d7d9dd2d-2af6-4fb7-8f55-5657b4fe15f7"}[currentProductHandle()];
    if (!priceSet) return null;
    const prefix = "#cl-set-" + priceSet + "-cl-option-";
    const front = document.querySelector(prefix + '100-cl-value-id-2');
    const rear = document.querySelector(prefix + '300-cl-value-id-2');
    const enabled = document.querySelector(prefix + '19');
    const f = Boolean(front && front.checked);
    const r = Boolean(enabled && enabled.checked && rear && rear.checked);
    if (!f && !r) ovalFirstImageSide = null;
    else if (f && !r) ovalFirstImageSide = "front";
    else if (r && !f) ovalFirstImageSide = "rear";
    else if (!ovalFirstImageSide) ovalFirstImageSide = "front";
    return {front:f, rear:r, first:ovalFirstImageSide};
  }

  function renderStylePrices(configuration) {
    const ovalPrices = ovalImagePriceState();
    document.querySelectorAll(engravingSelector).forEach(function (input) {
      var priceElement = ensureStylePrice(input);
      var group = input.closest('[role="radiogroup"]');
      if (!priceElement || !group) return;

      var identity = inputIdentity(input);
      var products = linkedProductsForInput(input, configuredOption(configuration, input));
      var compareProducts = [];
      if (isRearInput(input) && isImageValue(input.value)) {
        var frontImageSelected = Array.from(document.querySelectorAll(
          ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravurstil]"]:checked,' +
          ':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="radio"][name="properties[Gravur gestalten]"]:checked'
        )).some(function (frontInput) { return isImageValue(frontInput.value); });
        products = linkedProductsForSetHandle(configuration, identity && identity.setId, frontImageSelected ? "zweite-bildgravur" : "bildgravur");
        if (frontImageSelected) compareProducts = linkedProductsForSetHandle(configuration, identity && identity.setId, "bildgravur");
      }

        if (ovalPrices && isImageValue(input.value)) {
          const identity = inputIdentity(input);
          if (identity && ["1a893188-6601-48cc-b238-5e84a88feec6","d7d9dd2d-2af6-4fb7-8f55-5657b4fe15f7"].includes(identity.setId) &&
              ["100", "300"].includes(identity.optionId)) {
            const rearCard = identity.optionId === "300";
            const otherSelected = rearCard ? ovalPrices.front : ovalPrices.rear;
            const thisSelected = rearCard ? ovalPrices.rear : ovalPrices.front;
            const thisSide = rearCard ? "rear" : "front";
            const discounted = otherSelected && (!thisSelected || ovalPrices.first !== thisSide);
            products = linkedProductsForSetHandle(configuration, identity.setId,
              discounted ? "zweite-bildgravur" : "bildgravur");
            compareProducts = discounted
              ? linkedProductsForSetHandle(configuration, identity.setId, "bildgravur") : [];
          }
        }

      var key = products.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|") + "|compare:" + compareProducts.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|");

      priceElement.replaceChildren();
      priceElement.classList.remove("cardori-style-price--discount");
      priceElement.removeAttribute("aria-label");
      priceElement.setAttribute("data-cardori-products", key);
      if (!products.length) return;

      Promise.all([linkedPrice(products), compareProducts.length ? linkedPrice(compareProducts) : Promise.resolve(0)]).then(function (prices) {
        if (priceElement.getAttribute("data-cardori-products") !== key || prices[0] <= 0) return;
        var current = "+" + formatPrice(prices[0]);
        if (prices[1] > prices[0]) {
          var oldPrice = document.createElement("s");
          var currentPrice = document.createElement("span");
          oldPrice.className = "cardori-style-price-old";
          currentPrice.className = "cardori-style-price-current";
          oldPrice.textContent = "+" + formatPrice(prices[1]);
          currentPrice.textContent = current;
          priceElement.classList.add("cardori-style-price--discount");
          priceElement.setAttribute("aria-label", "Jetzt " + current + ", statt " + oldPrice.textContent);
          priceElement.append(oldPrice, currentPrice);
        } else {
          priceElement.textContent = current;
        }
        group.classList.add("cardori-group-has-price");
      }).catch(function () {
        priceElement.replaceChildren();
      });
    });
  }

  function ensureCheckboxPrice(container) {
    var price = container.querySelector(":scope > .cardori-upprice-text");
    if (!price) {
      price = document.createElement("small");
      price.className = "help-text cardori-upprice-text";
      container.insertBefore(price, container.querySelector(":scope > .bottom-spacer") || null);
    }
    return price;
  }

  function renderCheckboxPrices(configuration) {
    document.querySelectorAll(':is(#customily-options, .customily-modal-container, #csh-list-preview-modal, .csh-product-customizer-modal) input[type="checkbox"]').forEach(function (input) {
      var container = input.closest(".cl-option-content");
      if (!container) return;
      var products = linkedProductsForInput(input, configuredOption(configuration, input));
      var oldPrice = container.querySelector(":scope > .cardori-upprice-text");
      if (!products.length) {
        container.classList.remove("cardori-upprice-option");
        if (oldPrice) oldPrice.remove();
        return;
      }
      container.classList.add("cardori-upprice-option");
      var price = ensureCheckboxPrice(container);
      var key = products.map(function (item) {
        return [item.handle, item.variantId, item.quantity || 1].join(":");
      }).join("|");
      price.textContent = "";
      price.setAttribute("data-cardori-products", key);
      linkedPrice(products).then(function (cents) {
        if (cents > 0 && price.getAttribute("data-cardori-products") === key) price.textContent = "(+" + formatPrice(cents) + ")";
      }).catch(function () { price.textContent = ""; });
    });
  }

  function render() {
    renderTimer = 0;
    document.querySelectorAll(engravingSelector).forEach(ensureStylePrice);
    document.documentElement.setAttribute("data-cardori-price-status", "loading");
    loadConfiguration().then(function (configuration) {
      document.documentElement.setAttribute("data-cardori-price-status", "ready");
      renderStylePrices(configuration);
      renderCheckboxPrices(configuration);
    }).catch(function (error) {
      document.documentElement.setAttribute("data-cardori-price-status", "error");
      console.warn("CARDORI PILOT: linked prices unavailable", error);
    });
  }

  function queue() {
    if (renderTimer) return;
    renderTimer = window.setTimeout(render, 120);
  }

  document.addEventListener("change", queue, true);
  window.addEventListener("customily-options-loaded", queue);
  window.addEventListener("customily-options-changed", queue);
  window.addEventListener("customily-variation-change-finished", queue);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();
(function () {
  'use strict';
  var notice;
  var scheduled = false;
  var visible = false;
  var requestedButton = null;

  function refreshCartLoading() {
    scheduled = false;
    var button = document.getElementById('customily-cart-btn');
    var busy = !!(button && button === requestedButton && button.isConnected &&
      !button.classList.contains('is-success') &&
      (button.classList.contains('running') || button.classList.contains('is-loading')));
    if (busy === visible) return;
    var strings = window.theme && window.theme.strings;
    if (busy && (!strings || !strings.cardoriCartLoading)) return;
    if (busy && (!notice || notice.parentElement !== button)) {
      if (notice) notice.remove();
      notice = document.createElement('span');
      notice.className = 'cardori-cart-inline-loading';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.setAttribute('aria-atomic', 'true');
      var spinner = document.createElement('span');
      spinner.className = 'cardori-cart-inline-loading__spinner';
      spinner.setAttribute('aria-hidden', 'true');
      var title = document.createElement('span');
      title.textContent = strings.cardoriCartLoading;
      notice.append(spinner, title);
      button.appendChild(notice);
    }
    if (notice) {
      notice.hidden = !busy;
      if (notice.parentElement) notice.parentElement.classList.toggle('cardori-inline-loading', busy);
    }
    if (!busy) requestedButton = null;
    visible = busy;
  }

  function queueCartLoading() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refreshCartLoading);
  }

  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return record.type === 'childList' || record.target.id === 'customily-cart-btn';
    })) queueCartLoading();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  window.addEventListener('pageshow', queueCartLoading);
  window.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('#customily-cart-btn');
    if (!button) return;
    requestedButton = button;
    queueCartLoading();
  }, true);
  queueCartLoading();
})();

(function () {
  var body = document.body;
  if (!body || !body.classList.contains("cardori-customily-product")) return;

  var form = document.querySelector(".js-product-form");
  if (!form) {
    body.classList.remove("cardori-customily-loading");
    return;
  }

  var status = document.createElement("div");
  var spinner = document.createElement("span");
  var message = document.createElement("span");
  var retry = document.createElement("button");
  var observer;
  var timeout;

  status.className = "cardori-customily-initial-status";
  status.setAttribute("role", "status");
  status.setAttribute("aria-live", "polite");
  spinner.className = "cardori-customily-initial-status__spinner";
  spinner.setAttribute("aria-hidden", "true");
  message.className = "cardori-customily-initial-status__message";
  message.textContent = body.getAttribute("data-cardori-customily-loading-text") || "";
  retry.className = "cardori-customily-initial-status__retry";
  retry.type = "button";
  retry.textContent = body.getAttribute("data-cardori-customily-retry-text") || "";
  retry.hidden = true;
  retry.addEventListener("click", function () {
    window.location.reload();
  });
  status.append(spinner, message, retry);

  function mountStatus() {
    var target = form.querySelector(".quantity-submit-row__submit") || form;
    if (!status.isConnected) target.prepend(status);
  }

  function isReady() {
    // Native Modal Preview is ready when its personalization entry is usable.
    var entry = form.querySelector('#customily-personalize-button');
    if (entry && !entry.disabled && entry.getClientRects().length && !entry.classList.contains('running')) return true;
    // Product Page Preview and Show Preview Button retain their original checks.
    return Boolean(form.querySelector('#customily-options .customily-main-app') && form.querySelector('#customily-cart-btn') && form.querySelector('.hidden-cart-btn'));
  }

  function finish() {
    window.clearTimeout(timeout);
    if (observer) observer.disconnect();
    body.classList.remove("cardori-customily-loading", "cardori-customily-error");
    body.classList.add("cardori-customily-ready");
  }

  function check() {
    mountStatus();
    if (isReady()) finish();
  }

  observer = new MutationObserver(check);
  observer.observe(form, { childList: true, subtree: true });
  window.addEventListener("customily-options-loaded", check);
  window.addEventListener("customily-variation-change-finished", check);

  timeout = window.setTimeout(function () {
    if (isReady()) {
      finish();
      return;
    }
    body.classList.add("cardori-customily-error");
    status.setAttribute("role", "alert");
    spinner.hidden = true;
    message.textContent = body.getAttribute("data-cardori-customily-error-text") || "";
    retry.hidden = false;
    mountStatus();
  }, 15000);

  check();
})();

(() => {
  if (!/\/products\/personalisierter-armreif-mit-gravur-1\/?$/.test(location.pathname)) return;
  const pickerSelector = 'variant-picker[data-url="/products/personalisierter-armreif-mit-gravur-1"]';
  const colorSelector = 'fieldset[data-option="Farbe"]';
  const endSelector = 'fieldset[data-option="Endstück"]';
  function update(picker, event) {
    const color = picker.querySelector(colorSelector + ' input:checked')?.value;
    const ends = picker.querySelector(endSelector);
    const normal = ends?.querySelector('input[value="Normal"]');
    if (!ends || !normal) return;
    const restricted = color === 'Gold' || color === 'Silber';
    if (restricted && !normal.checked) {
      if (event) {
        normal.checked = true;
        delete event.target.dataset.variantId;
      } else {
        normal.click();
      }
    }
    const display = restricted ? 'none' : '';
    if (ends.style.display !== display) ends.style.display = display;
  }
  function refresh() {
    document.querySelectorAll(pickerSelector).forEach(picker => update(picker));
  }
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const picker = event.target.closest(pickerSelector);
    if (picker && event.target.closest(colorSelector)) update(picker, event);
  }, true);
  document.addEventListener('on:variant:change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  const root = document.querySelector('#content');
  if (root) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        refresh();
      });
    }).observe(root, { childList: true, subtree: true });
  }
  refresh();
})();

(() => {
  if (!/\/products\/personalisierter-armreif-mit-gravur-1\/?$/.test(location.pathname)) return;
  const replacements = {
    '42141380771999': '42112065306783',
    '43674477625608': '43674477592840',
    '42141380739231': '42112068649119',
    '42141380837535': '42112065339551',
    '43674477691144': '43674477658376',
    '42141380804767': '42112068681887'
  };
  const url = new URL(location.href);
  const replacement = replacements[url.searchParams.get('variant')];
  if (replacement) {
    url.searchParams.set('variant', replacement);
    location.replace(url.href);
  }
})();

/* CARDORI: Customily-linked cart groups. Only native group IDs establish ownership. */
(function () {
  'use strict';
  let cart = null, busy = false, timer = null, loading = null;
  const mainId = item => item?.properties?.['_customily-upsell-main-id'];
  const addonId = item => item?.properties?.['_customily-upsell-id'];
  const route = window.Shopify?.routes?.root || '/';
  const root = route.endsWith('/') ? route : route + '/';
  async function request(path, options) {
    const response = await fetch(root + path, Object.assign({credentials:'same-origin',headers:{'Accept':'application/json','Content-Type':'application/json'}},options));
    if(!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
    return response.json();
  }
  function present() {
    if(!cart) return;
    const count = cart.items.reduce((sum,item)=>sum+(addonId(item)?0:Number(item.quantity)||0),0);
    document.documentElement.dataset.cardoriCartProducts=String(count);
    document.querySelectorAll('.cart-link__count').forEach(node=>{if(node.textContent!==String(count))node.textContent=String(count);});
    document.querySelectorAll('.cart-drawer__title-count').forEach(node=>{const text='('+count+')';if(node.textContent!==text)node.textContent=text;});
    document.querySelectorAll('cart-form .cart-item__quantity-input').forEach(input=>{
      const item=cart.items.find(item=>item.key===input.dataset.key),row=input.closest('.cart-item');
      if(!row)return;
      if(mainId(item)) {
        row.dataset.cardoriCartGroup='main';
        row.dataset.cardoriLinkedAddons=String(cart.items.filter(child=>addonId(child)===mainId(item)).length);
      } else if(row.hasAttribute('data-cardori-cart-group')) {delete row.dataset.cardoriCartGroup;delete row.dataset.cardoriLinkedAddons;}
      const orphan=addonId(item)&&!cart.items.some(parent=>mainId(parent)===addonId(item));
      let remove=row.querySelector('.cardori-orphan-remove');
      if(orphan){
        row.dataset.cardoriCartGroup='orphan';if(row.style.getPropertyValue('display')!=='flex'||row.style.getPropertyPriority('display')!=='important')row.style.setProperty('display','flex','important');
        const qty=row.querySelector('.cart-item__quantity');if(qty&&(qty.style.getPropertyValue('display')!=='none'||qty.style.getPropertyPriority('display')!=='important'))qty.style.setProperty('display','none','important');
        if(!remove){remove=document.createElement('button');remove.type='button';remove.className='cardori-orphan-remove';remove.textContent='Gravur-Aufpreis entfernen';remove.style.cssText='border:0;background:none;text-decoration:underline;padding:8px 0;min-height:44px;cursor:pointer;color:inherit';(row.querySelector('.cart-item__description')||row).appendChild(remove);}
      } else if(remove){remove.remove();row.style.removeProperty('display');row.querySelector('.cart-item__quantity')?.style.removeProperty('display');}

    });
  }
  async function read() {
    if(loading)return loading;
    loading=request('cart.js?cardori_group_read=1').then(value=>{cart=value;present();return value;}).catch(error=>{console.warn('[CARDORI linked cart]',error);}).finally(()=>{loading=null;});
    return loading;
  }
  function queueRead(){clearTimeout(timer);timer=setTimeout(read,180);}
  function details(target){
    const input=target?.closest('cart-form .cart-item')?.querySelector('.cart-item__quantity-input');
    if(!input)return null;
    const item=cart?.items.find(item=>item.key===input.dataset.key);
    const orphan=addonId(item)&&!cart.items.some(parent=>mainId(parent)===addonId(item));
    return mainId(item)||orphan?{input,item,row:input.closest('.cart-item'),orphan:Boolean(orphan)}:null;
  }
  async function update(info, quantity) {
    if(busy)return;
    busy=true;info.row.setAttribute('aria-busy','true');
    document.documentElement.dataset.cardoriCartGroupUpdate='updating';
    info.row.querySelector('.cardori-cart-group-error')?.remove();
    try {
      const current=await request('cart.js?cardori_group_read=1');
      const item=current.items.find(item=>item.key===info.item.key);
      if(info.orphan){
        if(!addonId(item)||current.items.some(parent=>mainId(parent)===addonId(item)))throw new Error('Dieser Aufpreis gehört inzwischen zu einem Artikel. Bitte lade den Warenkorb neu.');
        const updates={[item.key]:0};
        cart=await request('cart/update.js?customily_upsell&cardori_group_update=1',{method:'POST',body:JSON.stringify({updates})});
        present();document.documentElement.dataset.cardoriCartGroupUpdate='success';document.dispatchEvent(new CustomEvent('on:cart:change',{bubbles:true}));return;
      }
      if(!mainId(item))throw new Error('Bitte lade den Warenkorb neu und versuche es erneut.');
      const group=mainId(item),parents=current.items.filter(parent=>mainId(parent)===group);
      const before=parents.reduce((sum,parent)=>sum+parent.quantity,0);
      const after=before-item.quantity+quantity;
      const updates={[item.key]:quantity};
      current.items.filter(child=>addonId(child)===group).forEach(child=>{
        updates[child.key]=after===0?0:Math.max(1,Math.round(child.quantity*after/before));
      });
      // Customily itself reserves this marker to avoid recursively intercepting a complete group update.
      cart=await request('cart/update.js?customily_upsell&cardori_group_update=1',{method:'POST',body:JSON.stringify({updates})});
      present();document.documentElement.dataset.cardoriCartGroupUpdate='success';
      document.dispatchEvent(new CustomEvent('on:cart:change',{bubbles:true}));
    } catch(error) {
      document.documentElement.dataset.cardoriCartGroupUpdate='error';
      const message=document.createElement('p');message.className='cardori-cart-group-error';message.setAttribute('role','alert');message.textContent=error.message;
      info.row.appendChild(message);console.error('[CARDORI linked cart]',error);
    } finally {busy=false;info.row.removeAttribute('aria-busy');}
  }
  window.addEventListener('click',event=>{
    if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    const control=event.target instanceof Element?event.target.closest('cart-form .cart-item__remove,cart-form .quantity-down,cart-form .quantity-up,cart-form .cardori-orphan-remove'):null;
    if(!control)return;
    const info=details(control);if(!info)return;
    event.preventDefault();event.stopImmediatePropagation();
    let quantity=Number(info.input.value)||0;
    if(control.matches('.cart-item__remove,.cardori-orphan-remove'))quantity=0;
    else quantity+=control.matches('.quantity-up')?1:-1;
    quantity=Math.max(0,quantity);if(info.input.max)quantity=Math.min(quantity,Number(info.input.max));
    update(info,quantity);
  },true);
  window.addEventListener('change',event=>{
    if(!(event.target instanceof Element)||!event.target.matches('cart-form .cart-item__quantity-input'))return;
    const info=details(event.target);if(!info)return;
    event.preventDefault();event.stopImmediatePropagation();
    let quantity=Math.max(0,Number(info.input.value)||0);if(info.input.max)quantity=Math.min(quantity,Number(info.input.max));
    update(info,quantity);
  },true);
  function start(){
    const style=document.createElement('style');style.id='cardori-orphan-cart-visibility';style.textContent='cart-form .cart-item[data-cardori-cart-group="orphan"]{display:flex!important}cart-form .cart-item[data-cardori-cart-group="orphan"] .cart-item__quantity{display:none!important}cart-form .cart-item[data-cardori-cart-group="orphan"] .cardori-orphan-remove{visibility:visible!important;display:inline-block!important;pointer-events:auto!important}';document.head.appendChild(style);
    read();
    const observer=new MutationObserver(present);
    document.querySelectorAll('cart-form,.cart-link,cart-drawer').forEach(node=>observer.observe(node,{childList:true,subtree:true,attributes:true,attributeFilter:['style']}));
  }
  ['on:cart:add','on:cart:change','on:cart:after-merge','on:cart-drawer:before-open'].forEach(name=>document.addEventListener(name,queueRead));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

// Oval: never submit a native text object whose renderer has dropped characters.
(function () {
  if (!location.pathname.includes('/products/oval-schlusselanhanger-mit-gravur-handschrift-gravur')) return;
  var errors = new Map();
  function checkTextFit() {
    var engine = window.engraver;
    if (engine?.currentProduct?.id !== '4c75712a-b19c-4f78-a86c-c84223138d2d' || !engine.canvas) return [];
    var bad=[];
    [[901,102],[1901,202]].forEach(function(pair) {
      var field=document.querySelector('[id$="cl-option-'+pair[1]+'"]');
      if(!field || !field.value.trim()) return;
      var objects=engine.canvas.getObjects().filter(function(item) { return Number(item.id)===pair[0] && item.type==='bounded-text' && !item.outsideCanvas && !item.hideGroup && item.getText().trim(); });
      var invalid=objects.some(function(item) { return Boolean(item.item(0).deletedChars); });
      var message=invalid ? 'Der Text passt noch nicht vollständig. Bitte füge einen Zeilenumbruch ein oder kürze den Text.' : '';
      field.setCustomValidity(message); field.setAttribute('aria-invalid',String(invalid));
      var hint=errors.get(field);
      if(!hint) { hint=document.createElement('p'); hint.className='cardori-text-fit-error'; hint.setAttribute('role','status'); hint.style.cssText='color:#9f2424;font-size:14px;line-height:1.4;margin:6px 0 0'; field.insertAdjacentElement('afterend',hint); errors.set(field,hint); }
      hint.textContent=message; hint.hidden=!invalid;
      if(invalid) bad.push(field);
    });
    return bad;
  }
  setInterval(checkTextFit,300);
  window.addEventListener('click',function(event) {
    var button=event.target.closest('button');
    if(!button || !(button.id==='customily-cart-btn' || (button.closest('.customily-modal-container') && /weiter|warenkorb/i.test(button.textContent)))) return;
    var bad=checkTextFit(); if(!bad.length)return;
    event.preventDefault(); event.stopImmediatePropagation();
    var field=bad[0]; field.scrollIntoView({block:'center',behavior:'auto'}); field.focus({preventScroll:true}); field.reportValidity();
  },true);
})();

/* CARDORI 2026-10-10: preserve quoted personalization text during native form transfer. */
(function () {
  const quoted = new Map();
  function capture() {
    quoted.clear();
    document.querySelectorAll('.customily_option input[type="text"][name^="properties["],.customily_option textarea[name^="properties["]').forEach(field => {
      if (!field.disabled && field.value.includes('"')) quoted.set(field.name, field.value);
    });
  }
  window.addEventListener('click', event => {
    if (event.target.closest('#customily-cart-btn,.cl-add-to-cart')) capture();
  }, true);
  document.addEventListener('formdata', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    quoted.forEach((value, name) => { if (event.formData.has(name)) event.formData.set(name, value); });
  }, true);
  new MutationObserver(() => {
    quoted.forEach((value, name) => {
      document.querySelectorAll('form[action*="/cart/add"] input[type="hidden"]').forEach(field => {
        if (field.name === name && field.value !== value) field.value = value;
      });
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();

/* CARDORI 2026-10-25: examples for verified ready-only upload option sets. */
(function () {
  var readySets = ['17aaad5a-1448-4b83-9553-a6192d4dc6a8', '7dbf7bef-14cf-4922-9565-295a90ba5ad1', 'c702e902-1384-4b61-9937-8dddd04ea718', 'ea0ae6d1-eeca-43d6-bb54-79ac0fac64ab', 'be930359-dafd-40e2-8427-96fd4cc708bb', '0862cf36-b476-4a4b-bcf4-0b459d902804'];
  var scheduled = false;
  function updateReadyExamples() {
    scheduled = false;
    readySets.forEach(function (setId) {
      document.querySelectorAll('[set-id="' + setId + '"] .customily_option').forEach(function (option) {
        if (!option.querySelector('input[type="file"]') || option.querySelector('[data-cardori-ready-only-examples]')) return;
        var guide = document.createElement('div');
        guide.className = 'cardori-upload-guide';
        guide.setAttribute('data-cardori-ready-only-examples', 'true');
        guide.innerHTML = cardoriUploadGuideMarkup20261024('ready');
        option.appendChild(guide);
        cardoriBindUploadExamples20261024(guide, option);
      });
    });
  }
  function scheduleReadyExamples() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(updateReadyExamples, 0);
  }
  function startReadyExamples() {
    updateReadyExamples();
    new MutationObserver(scheduleReadyExamples).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startReadyExamples, {once: true});
  else startReadyExamples();
})();

